export default {
    "goods_category_page_title": "Categories",
    "goods_category_product": "Product",
    "goods_category_default": "Default",
    "goods_category_sales": "Sales",
    "goods_category_filter_brand": "Filter brands",
    "goods_category_brand": "Brand",
    "goods_category_sub_brand": "Sub-brand",
    "goods_category_reset": "Reset",
    "goods_category_confirm": "Confirm",
    "goods_category_retry": "Retry",
    "goods_category_page_load_failed": "Failed to load categories",
    "goods_category_child_load_failed": "Failed to load subcategories",
    "goods_category_brand_load_failed": "Failed to load brands",
    "goods_category_goods_load_failed": "Failed to load products",
    "goods_category_empty_category": "No categories",
    "goods_category_empty_category_desc": "Please try again later",
    "goods_category_empty_child": "No subcategories",
    "goods_category_empty_goods": "No products",
    "goods_category_empty_goods_desc": "Try another category or brand",
    "goods_category_load_more_failed": "Load failed. Tap to retry",
    "goods_category_no_more": "All products loaded",
    "goods_category_promotion_price": "Promotion",
    "goods_category_tomo_price": "TOMO Price",
    "just_a_bit": "Just a bit",
    "not_damaged_at_all": "Not damaged at all",
    "level_1_category": "Level 1 Category",
    "lets_browse_shop_together": "Let's browse this shop together",
    "one_click_bind": "One-click Bind",
    "seven_day_lord": "7-Day Lord",
    "ten_thousand": "Ten Thousand",
    "ten_thousand_yuan": "Ten Thousand Yuan",
    "mixc_mall": "The Mixc",
    "three_weeks_full_attendance": "Three weeks full attendance for immortal achievements",
    "three_days_company": "Three Days Company",
    "three_days_company_reward": "Fruitful reward for three days company",
    "context": "Context",
    "uploading": "Uploading",
    "uploading_mask": "Uploading Mask",
    "upload_voucher": "Upload Voucher",
    "upload_face_image_failed": "Failed to upload face image",
    "upload_response_format_error": "Upload response format error",
    "upload_after_sales_desc_hint": "Uploading description helps process the issue",
    "upload_image": "Upload Image",
    "upload_failed": "Upload Failed",
    "upload_id_card_hint": "Upload ID card for automatic recognition",
    "upload_unknown_error": "Unknown error during upload",
    "upload_bank_card_hint": "Upload bank card for automatic recognition",
    "pull_up_to_load_more": "Pull up to load more",
    "shanghai_city": "Shanghai",
    "next_step": "Next Step",
    "next_step_button": "Next Button",
    "order_time": "Order Time",
    "download": "Download",
    "downloading": "Downloading",
    "download_all_images_and_copy_info": "Download all images and copy product info",
    "download_all_button": "Download All Button",
    "download_to_album": "Download to Album",
    "download_not_implemented": "Download feature not implemented yet",
    "after_download": "After Download",
    "download_product_image": "Download Product Image",
    "download_images_publish_hint": "Download images and info to publish on your platform",
    "download_image_failed": "Failed to download image",
    "download_url_not_configured": "Download URL not configured",
    "download_url_config_loaded": "Download URL config loaded",
    "download_url_config_updated": "Download URL config updated",
    "download_failed": "Download Failed",
    "download_success": "Download Success",
    "download_button": "Download Button",
    "download_poster": "Download Poster",
    "download_poster_share_moment": "Download poster to share on Moments",
    "download_poster_button": "Download Poster Button",
    "download_certificate": "Download Certificate",
    "download_timeout": "Download Timeout",
    "download_territory": "Download Territory",
    "download_territory_code": "Download Territory Code",
    "not_just_joining": "Not just joining",
    "no_decimals_allowed": "Decimals not allowed",
    "cannot_close": "Cannot Close",
    "disagree": "Disagree",
    "refund_not_supported": "Refund Not Supported",
    "show_none_selected": "Show none selected",
    "cannot_select_more_than": "Cannot select more than",
    "unlimited": "Unlimited",
    "unlimited_people": "Unlimited People",
    "unlimited_stock": "Unlimited Stock",
    "distributor_scroll_list": "Distributor Scroll List",
    "exclusive_task": "Exclusive Task",
    "exclusive_params": "Exclusive Params",
    "exclusive_digital_space": "Exclusive Digital Space",
    "exclusive_identity": "Exclusive Identity",
    "exclusive_identity_badge": "Exclusive Identity Badge",
    "and_agree_to_protocols": "and agree to the following protocols",
    "and_allow_comments": "and allow comments",
    "business_metrics": "Business Metrics",
    "justify_between": "Justify Between",
    "strictly_selected_goods": "Strictly Selected Goods",
    "count_unit": "items",
    "events_count": "Events Count",
    "personal": "Personal",
    "personal_center": "Personal Center",
    "personal_updates": "Personal Updates",
    "personal_contribution": "Personal Contribution",
    "personal_contribution_detail": "Personal Contribution Detail",
    "personal_contribution_desc": "Personal Contribution Description",
    "personal_assets": "Personal Assets",
    "tasks_count": "Tasks Count",
    "products_count": "Products Count",
    "after_sales_reason_required": "After-sales reason cannot be empty for product",
    "product_status_required": "Product status cannot be empty for product",
    "refund_amount_required": "Refund amount cannot be empty for product",
    "refund_amount_format_error": "Refund amount format incorrect for product",
    "signature": "Signature",
    "digital_assets_pending": "You have {count} digital assets to claim",
    "merchant_audit_failed_msg": "Unfortunately, your merchant certification audit failed. The reasons are as follows:",
    "store_audit_failed_msg": "Unfortunately, your store certification audit failed. The reasons are as follows:",
    "merchant_audit_success_msg": "Congratulations, your merchant certification audit has passed",
    "store_join_success_msg": "Congratulations, your store has joined the territory",
    "if_join_store_guide": "If you need to settle in a store, please click the button below to operate.",
    "store_manage_guide": "You can search for the 'Territory Alliance' mini-program on WeChat and enter the username and password from the SMS to manage the store.",
    "digital_wallet_guide": "Click the button below to open a digital wallet and claim digital assets for free to enjoy exclusive benefits",
    "explore_new_world_msg": "Go explore the new world in the territory~",
    "gift_check_guide": "{content}, click the button below to view",
    "download_to_join_msg": "Download the Territory App, hold digital assets, and you can join",
    "activities_count": "Activities Count",
    "red_packets_total": "Red Packets Total",
    "territory_members_holding_this": "Territory members holding this",
    "territory_members_holding_asset": "Territory members holding this digital asset",
    "taiwan_residents": "Taiwan Residents",
    "mainland_residents": "Mainland Residents",
    "macau_residents": "Macau Residents",
    "cmcc_auth_terms": "China Mobile Auth Terms",
    "hongkong_residents": "Hong Kong Residents",
    "mapped_to_in": "Mapped to in",
    "not_found_in": "Not found in",
    "middle_section": "Middle Section",
    "configured_in": "Configured in",
    "center": "Center",
    "center_bump": "Center Bump",
    "center_text_info": "Center Text Info",
    "center_bulge": "Center Bulge",
    "temp_closed": "Temporarily Closed",
    "protect_rights": "To protect your legal rights",
    "protect_your_rights": "To protect your rights",
    "protect_account_assets": "To protect your account and assets",
    "convenience_for_developers": "For convenience of more developers",
    "main_dist_detail": "Main Distribution Detail",
    "main_image_area": "Main Image Area",
    "main_dist_product_detail": "Main Distribution Product Detail",
    "main_dist_detail_short": "Main Dist Detail",
    "main_content": "Main Content",
    "main_content_area": "Main Content Area",
    "main_notice_bar": "Main Notice Bar",
    "home_page": "Home Page",
    "report": "Report",
    "report_success": "Report Success",
    "event_queued": "Event Queued",
    "event_sent": "Event Sent",
    "event_passed": "Event Passed",
    "event_retry": "Event Retry",
    "event_retry_limit": "Event retry limit reached",
    "qrcode": "QR Code",
    "qrcode_saved": "QR Code Scanned",
    "qrcode_content_required": "QR Code content required",
    "qrcode_area": "QR Code Area",
    "qrcode_desc": "QR Code Description",
    "qrcode_display_area": "QR Code Display Area",
    "qrcode_generating": "QR Code Generating",
    "yunnan_signboard": "Yunnan Signboard",
    "yunnan_restaurant_available": "Available in Yunnan Select Restaurants",
    "mutual_follow_action": "Follow Back",
    "interaction_data_row": "Interaction Data Row",
    "mutual_follow": "Mutual Follow",
    "five_star_rating": "Five Star Rating",
    "transaction_list": "Transaction List",
    "transaction_no": "Transaction No",
    "transaction_cancelled": "Transaction Cancelled",
    "transaction_count": "Transaction Count",
    "enjoy_exclusive_rights": "Enjoy Exclusive Rights",
    "person": "Person",
    "people_distributed": "People Distributed",
    "people_participated": "People Participated",
    "people_collaborated": "People Collaborated",
    "personnel_list_container": "Personnel List Container",
    "people_consulted": "People Consulted",
    "people_online": "People Online",
    "people_joined": "People Joined",
    "people_registered": "People Registered",
    "people_holding": "People Holding",
    "people_brought": "People Brought",
    "people_hold": "People Hold",
    "people_chatting": "People Chatting",
    "people_operating": "People Operating",
    "connections": "Connections",
    "connection_coorperation": "Connection Cooperation",
    "connection_skills": "Connection Skills",
    "face_auth": "Face Auth",
    "face_verify_success": "Face Verification Success",
    "people_earned_commission": "People Earned Commission",
    "people_liked_post": "People Liked Your Post",
    "people_liked_comment": "People Liked Your Comment",
    "people_booked": "People Booked",
    "people_dining": "People Dining",
    "what_is_contribution": "What is Personal Contribution",
    "what_is_digital_assets": "What are Digital Assets",
    "what_is_estimated_commission": "What is Estimated Commission",
    "left_nothing": "Left nothing",
    "fallback_only": "Fallback Only",
    "only_left": "Only Left",
    "wechat_only_and": "WeChat Only And",
    "button_only": "Button Only",
    "refund_only": "Refund Only",
    "today": "Today",
    "today_purchasable": "Available Today",
    "today_purchase_limit_reached": "Today's purchase limit reached",
    "today_earnings": "Today Earnings",
    "today_order": "Today Order No.",
    "today_checkin_reward": "Today Check-in Reward",
    "today_invite_count": "Today Invite Count",
    "intro_no_politics": "Do not include political content in introduction",
    "from": "From",
    "from_own_showcase": "From Own Showcase",
    "transparent_to_black": "Transparent to Black",
    "territories_he_joined": "Territories Joined",
    "digital_assets_he_holds": "Digital Assets Held",
    "payment_time": "Payment Time",
    "help_fill_logistics": "Help Fill Logistics",
    "voucher": "Voucher",
    "voucher_product": "Voucher Product",
    "following": "Following",
    "following_content_depend_on": "The following content depends on selected",
    "dashboard": "Dashboard",
    "piece": "piece",
    "items_product": "Items",
    "value": "Value",
    "value_burst": "Value Burst",
    "price": "Price",
    "price_info": "Price Info",
    "price_info_card": "Price Info Card",
    "price_area": "Price Area",
    "price_and_quantity": "Price and Quantity",
    "price_number": "Price Number",
    "price_display": "Price Display",
    "task": "Task",
    "place_to_win_attention": "Place to win attention via tasks",
    "task_square": "Task Square",
    "portion": "Potion",
    "discount_info": "Discount Info",
    "coupon": "Coupon",
    "coupon_info": "Coupon Info",
    "coupon_content": "Coupon Content",
    "coupon_list": "Coupon List",
    "coupon_tag": "Coupon Tag",
    "member": "Member",
    "member_operation_desc": "Member operation accumulates traffic assets",
    "everyday_at": "Everyday at",
    "recommend_to_friend": "Recommend to Friend",
    "bit": "Bit",
    "above_separator": "Above Separator",
    "member_count_unit": "members",
    "digit_verification_code": "-digit verification code",
    "location": "Location",
    "low_price_recharge_scam": "Low price recharge scam",
    "experience": "Experience",
    "merchants_available": "Merchants Available",
    "balance": "Balance",
    "balance_display": "Balance Display",
    "author": "Author",
    "author_reply": "Author Reply",
    "author_liked": "Author Liked",
    "search_via_wechat": "You can search via WeChat",
    "hello": "Hello",
    "level_image_cool": "Your level image will be cooler",
    "identity_badge_display": "Your identity badge will show next to avatar",
    "merchant_auth_approved": "Merchant Auth Approved",
    "merchant_auth_rejected": "Merchant Auth Rejected",
    "friend_shared_post": "Your friend shared a post",
    "digital_identity_waiting": "Your digital identity is waiting",
    "every_participation": "Your every participation",
    "every_contribution_convert": "Your every contribution converts to",
    "store_joined_territory": "Your store joined territory",
    "store_auth_rejected": "Store Auth Rejected",
    "commission": "Commission",
    "commission_card": "Commission Card",
    "commission_price_row": "Commission Price Row",
    "commission_data": "Commission Data",
    "commission_rate": "Commission Rate",
    "higher_commission": "Higher Commission",
    "wear": "Wear",
    "wear_success": "Wear Success",
    "use": "Use",
    "use_main_image_as_thumb": "Use main image as thumbnail",
    "use_time": "Use Time",
    "usage_process": "Usage Process",
    "usage_rules": "Usage Rules",
    "usage_record": "Usage Record",
    "usage_instructions": "Usage Instructions",
    "usage_notice": "Usage Notice",
    "use_default_config": "Use Default Config",
    "promotion": "Promotion",
    "promotion_activity": "Promotion Activity",
    "save": "Save",
    "saving": "Saving",
    "save_image": "Save Image",
    "save_failed": "Save Failed",
    "save_avatar": "Save Avatar",
    "save_success": "Save Success",
    "save_to_album": "Save to Album",
    "secret": "Secret",
    "info_area": "Info Area",
    "info_error": "Info Error",
    "modify": "Modify",
    "modify_after_sales_apply": "Modify After-sales Application",
    "modify_after_sales_submitted": "After-sales application modification submitted",
    "modify_failed": "Modification Failed",
    "modify_account_info": "Modify Account Info",
    "modify_success": "Modification Success",
    "modify_address": "Modify Address",
    "modify_nickname": "Modify Nickname",
    "modify_tags": "Modify Tags",
    "modify_application": "Modify Application",
    "modify_signature": "Modify Signature",
    "modify_profile": "Modify Profile",
    "modify_territory_name": "Modify Territory Name",
    "countdown": "Countdown",
    "parking": "Parking",
    "yuan": "Yuan",
    "yuan_all_category_voucher": "Yuan All-Category Voucher",
    "yuan_available": "Yuan Available",
    "full_energy_checkin": "Full of energy to check in",
    "element": "Element",
    "yuan_red_packet_await": "Yuan Red Packet and Exclusive Benefits Awaiting",
    "yuan_dining_voucher": "Yuan Dining Voucher",
    "recharge": "Recharge",
    "confirm_age_before_recharge": "Please confirm you are of age before recharging",
    "recharge_protocol_hint": "Recharge Protocol Hint",
    "recharge_failed": "Recharge Failed",
    "recharge_exception": "Recharge Exception",
    "recharge_success": "Recharge Success",
    "recharge_button": "Recharge Button",
    "recharge_buffer_time_hint": "Buffer time required for recharge purchase",
    "recharge_options_grid": "Recharge Options Grid",
    "recharge_diamond": "Recharge Diamond",
    "delete_one_first": "Delete one first",
    "served_first": "First come first served",
    "free": "Free",
    "no_reservation_needed": "No Reservation Needed",
    "join_store": "Join Store",
    "nationwide_chain": "Nationwide Chain",
    "available_all_day": "Available All Day",
    "fullscreen_overlay": "Fullscreen Overlay",
    "store_wide_use": "Store-wide Use",
    "visible_to_all_users": "Visible to all users",
    "select_all": "Select All",
    "all": "All",
    "all_products": "All Products",
    "all_combos": "All Combos",
    "all_shops": "All Shops",
    "withdraw_all": "Withdraw All",
    "all_messages": "All Messages",
    "all_orders": "All Orders",
    "all_stores": "All Stores",
    "public_channel": "Public Channel",
    "company": "Company",
    "km": "km",
    "total": "Total",
    "total_discount": "Total Discount",
    "total_profit_share": "Total Profit Share",
    "boost_brand_value_together": "Boost Brand Value Together",
    "governance_profit_share": "Governance Profit Share",
    "total_saved": "Total Saved",
    "about_us": "About Us",
    "about_territory": "About Territory",
    "follow": "Follow",
    "followed_you": "followed you",
    "follow_success": "Follow Success",
    "follow_button": "Follow Button",
    "follow_messages": "Follow Messages",
    "follow_related": "Follow Related",
    "relation_graph_area": "Relation Graph Area",
    "relation_graph_canvas": "Relation Graph Canvas",
    "close": "Close",
    "close_button": "Close Button",
    "interest_tags": "Interest Tags",
    "others": "Others",
    "other_country_residents": "Residents of other countries or regions",
    "other_icons_list": "Other Icons List",
    "other_miniapps_via": "Other MiniPrograms Via",
    "others_unchanged": "Others Unchanged",
    "login_other_phone": "Login with other phone",
    "other_share_page_types": "Other Share Page Types",
    "other_rules": "Other Rules",
    "other_pages_no_setting": "Other pages do not need setting",
    "compatible": "Compatible",
    "content": "Content",
    "content_empty": "Content Empty",
    "content_unchanged": "Content Unchanged",
    "content_share_card": "Content Share Card",
    "content_area": "Content Area",
    "content_card_template": "Content Card Template",
    "content_customizable": "Content Customizable",
    "content_and_comments": "Content and Comments",
    "content_image": "Content Image",
    "content_cover": "Content Cover",
    "content_layer": "Content Layer",
    "content_box": "Content Box",
    "content_details": "Content Details",
    "content_part": "Content Part",
    "even_the_smallest_individual": "Even the smallest individual",
    "order_again": "Order Again",
    "verify_again": "Verify Again",
    "try_again": "Try Again",
    "minus": "Minus",
    "top_seller": "Top Seller",
    "minute": "Minute",
    "share": "Share",
    "sharing": "Sharing",
    "share_to_miniapp_failed": "Failed to share to MiniProgram",
    "share_card": "Share Card",
    "share_card_failed": "Share Card Failed",
    "share_monetization": "Share Monetization",
    "share_product": "Share Product",
    "share_failed": "Share Failed",
    "share_miniapp_card_image": "Share MiniProgram Card Image",
    "share_guide_modal": "Share Guide Modal",
    "share_modal": "Share Modal",
    "share_modal_component": "Share Modal Component",
    "share_wechat": "Share WeChat",
    "share_button": "Share Button",
    "share_button_area": "Share Button Area",
    "share_moments": "Share Moments",
    "share_poster": "Share Poster",
    "share_component": "Share Component",
    "share_interesting_user": "Sharing an interesting Territory user with you",
    "share_to_friends": "Share to Friends",
    "share_to": "Share to",
    "share_earn_money": "Share to Earn",
    "divider": "Divider",
    "split_percentage": "Split Percentage",
    "analyzing_image_color": "Analyzing image color",
    "profit_share": "Profit Share",
    "category_selector": "Category Selector",
    "group_button": "Group Button",
    "group_title": "Group Title",
    "minutes": "Minutes",
    "minutes_ago": "minutes ago",
    "sold_out_in_minutes": "Sold out in minutes",
    "distributor_list": "Distributor List",
    "distributor_status": "Distributor Status",
    "distributor_level": "Distributor Level",
    "distributor_product_page": "Distributor Product Page",
    "distribute_group_buy": "Distribute Group Buy",
    "distribute_group_buy_detail": "Distribute Group Buy Detail",
    "distribute_group_detail": "Distribute Group Detail",
    "distribute_earn_commission": "Distribute to Earn Commission",
    "distribute_max_earn": "Distribute to Earn Max",
    "distribution_module": "Distribution Module",
    "distribute_this_product": "Distribute This Product",
    "distribute_retail_product": "Distribute Retail Product",
    "distribute_retail_product_detail": "Distribute Retail Product Detail",
    "separator": "Separator",
    "separator_line": "Separator Line",
    "switch": "Switch",
    "switch_failed": "Switch Failed",
    "switch_nav": "Switch Nav",
    "switch_login": "Switch Login",
    "list": "List",
    "just_now": "Just now",
    "create": "Create",
    "creator": "Creator",
    "create_verb": "Create",
    "create_new_territory": "Create New Territory",
    "create_time": "Create Time",
    "creator_noun": "Creator",
    "create_order_event": "Create Order Event",
    "create_territory": "Create Territory",
    "init_share_data_failed": "Failed to init share data",
    "init_failed": "Init Failed",
    "init_completed": "Init Completed",
    "init_config_params": "Init Config Params",
    "delete": "Delete",
    "deleting": "Deleting",
    "delete_in_detail_page": "Please delete in detail page",
    "delete_post_warning": "Post will disappear from all scenes after deletion",
    "delete_address": "Delete Address",
    "delete_success": "Delete Success",
    "free_gift_in_store": "Get free gift when visiting store",
    "checkin_post_after_store_visit": "Post check-in after store visit",
    "final_price": "Final Price",
    "final_price_text": "Final Price Text",
    "arrival_bank_card": "Arrival Bank Card",
    "refresh_success": "Refresh Success",
    "coupon_code": "Coupon Code",
    "open_browser_paste": "Go to browser, paste and open",
    "remaining": "Remaining",
    "remaining_stock": "Remaining Stock",
    "remaining_payment_time": "Remaining Payment Time",
    "join": "Join",
    "add_to_showcase_failed": "Failed to add to showcase",
    "add_to_cart": "Add to Cart",
    "join_territory": "Join Territory",
    "join_territory_interact": "Join Territory and interact with members",
    "join_territory_pact": "Join Territory Pact",
    "join_territory_merchant_alliance": "Join Territory Merchant Alliance",
    "join_territory_success": "Join Territory Success",
    "add_wechat_join_group": "Add WeChat to Join Group",
    "add_showcase": "Add to Showcase",
    "loading": "Loading",
    "loading_status": "Loading",
    "loading_failed": "Loading Failed",
    "loading_hint": "Loading Hint",
    "load_more": "Load More",
    "load_more_hint": "Load More Hint",
    "loading_state": "Loading State",
    "loading_indicator": "Loading Indicator",
    "add_selection_library": "Add to Selection Library",
    "accelerate_brand_value": "Accelerate Brand Value",
    "moments": "Moments",
    "dynamic_recharge": "Dynamic Recharge",
    "dynamic_param_trigger": "Dynamic Param Trigger",
    "dynamic_param_trigger_failed": "Dynamic Param Trigger Failed",
    "dynamic_param_trigger_completed": "Dynamic Param Trigger Completed",
    "moment_posted": "Moment Posted",
    "moment_deleted": "Moment Deleted",
    "moment_detail": "Moment Detail",
    "moments_channel": "Moments Channel",
    "animation_container": "Animation Container",
    "medal": "Medal",
    "wrap_container_for_animation": "Wrap container for animation",
    "well_packaged": "Well Packaged",
    "exquisite_packaging": "Exquisite Packaging",
    "free_shipping": "Free Shipping",
    "beijing": "Beijing",
    "beijing_territory": "Beijing Territory",
    "craftsmanship": "Craftsmanship",
    "district": "District",
    "district_county": "District/County",
    "district_list": "District List",
    "district_level": "District Level",
    "blockchain_collection_certificate": "Blockchain Collection Certificate",
    "blockchain_certificate": "Blockchain Certificate",
    "area": "Area",
    "area_content": "Area Content",
    "area_chart": "Area Chart",
    "ten_days_breakthrough": "Ten days breakthrough",
    "upgrade_identity": "Upgrade Identity",
    "half_year_sales": "Half Year Sales",
    "half_star": "Half Star",
    "halfway_champion": "Halfway Champion",
    "negotiation_history": "Negotiation History",
    "protocol_content": "Protocol Content",
    "protocol_check": "Protocol Check",
    "protocol_modal": "Protocol Modal",
    "single": "Single",
    "single_avatar": "Single Avatar",
    "single_amount": "Single Amount",
    "sell_product_earn_commission": "Sell Product Earn Commission",
    "placeholder": "Placeholder",
    "card_area": "Card Area",
    "card_container": "Card Container",
    "card_size": "Card Size",
    "card_template": "Card Template",
    "card_background": "Card Background",
    "place_order_now": "Place Order Now",
    "claim_digital_asset_free": "Claim Digital Asset Free",
    "join_now": "Join Now",
    "join_this_territory_now": "Join This Territory Now",
    "join_territory_now": "Join Territory Now",
    "open_digital_wallet_now": "Open Digital Wallet Now",
    "become_distributor_open_wallet": "Become Distributor and Open Wallet",
    "reason": "Reason",
    "reason_below": "Reason below",
    "original": "Original",
    "go_to_order": "Order Now",
    "go_to_pay": "Pay Now",
    "go_to_use": "Use Now",
    "go_to_recharge": "Recharge Now",
    "go_to_share": "Share",
    "go_share_moments": "Share to Moments",
    "go_browse_elsewhere": "Go browse elsewhere~",
    "go_post": "Post",
    "go_activate": "Activate",
    "go_open": "Open",
    "go_promote": "Promote",
    "go_pay": "Pay",
    "go_update": "Update",
    "go_view": "View",
    "go_like": "Like",
    "go_checkin": "Check In",
    "go_settle": "Settle",
    "go_setting": "Settings",
    "go_comment": "Comment",
    "go_buy": "Buy",
    "go_gift": "Gift",
    "go_invite": "Invite",
    "go_claim": "Claim",
    "join_brand_alliance_earn": "Join Brand Alliance and Earn Revenue",
    "join_alliance": "Join Alliance",
    "participate": "Participate",
    "params": "Params",
    "in_params": "In Params",
    "params_failed": "Params Failed",
    "params_error": "Params Error",
    "two_way_bind_search": "Two-way Bind Search",
    "sent_red_packets": "Sent Red Packets",
    "post_moment": "Post Moment",
    "on_sale": "On Sale",
    "release_calendar": "Release Calendar",
    "posted_at": "Posted at",
    "post_button": "Post Button",
    "post_activity": "Post Activity",
    "post_get_rewards_hint": "Post to get more rewards",
    "post_show_off": "Post to show off",
    "send_danmu": "Send Danmu",
    "post_service": "Post Service",
    "post_event": "Post Event",
    "invoice_apply": "Invoice Apply",
    "send_red_packet": "Send Red Packet",
    "issue": "Issue",
    "issue_info": "Issue Info",
    "issue_platform": "Issue Platform",
    "issuer": "Issuer",
    "ship": "Ship",
    "shipping_origin": "Shipping Origin",
    "fast_shipping": "Fast Shipping",
    "initiate_and_host_success": "Initiate and Host Success",
    "send": "Send",
    "sending": "Sending",
    "send_location": "Send Location",
    "send_failed": "Send Failed",
    "send_exception": "Send Exception",
    "send_success": "Send Success",
    "send_red_envelope": "Send Red Envelope",
    "pick_a_loud_name": "Pick a loud name",
    "cancel": "Cancel",
    "unequip": "Unequip",
    "unfollow": "Unfollow",
    "unfollow_failed": "Unfollow Failed",
    "unfollow_success": "Unfollow Success",
    "unfollow_confirm_modal": "Unfollow Confirm Modal",
    "cancel_reason": "Cancel Reason",
    "cancel_success": "Cancel Success",
    "cancel_button": "Cancel Button",
    "cancel_payment": "Cancel Payment",
    "cancel_time": "Cancel Time",
    "unlike": "Unlike",
    "cancel_reason_text": "Cancel Reason Text",
    "cancel_remove": "Cancel Remove",
    "unpin": "Unpin",
    "cancel_order": "Cancel Order",
    "cancel_order_failed": "Cancel Order Failed",
    "cancel_order_success": "Cancel Order Success",
    "pickup_time": "Pickup Time",
    "monetize_revenue_sustainable": "Sustainable revenue monetization",
    "only_show": "Only Show",
    "select_one_video_only": "Can only select one video",
    "can_upload_multiple": "Can upload multiple",
    "can_in": "Can in",
    "available": "Available",
    "can_get_free": "Can get for free",
    "can_at": "Can at",
    "withdrawable_amount": "Withdrawable Amount",
    "replaceable": "Replaceable",
    "add_content_as_needed": "Add content as needed",
    "can_perform": "Can perform",
    "available_alt": "Available",
    "available_time": "Available Time",
    "available_stores": "Available Stores",
    "maybe_invalid": "Maybe invalid",
    "proxy_config_error_maybe": "Proxy config error maybe",
    "can_obtain": "Can obtain",
    "can_get_avatar_frame": "Can get avatar frame",
    "can_get_rewards": "Can get rewards",
    "can_earn": "Can earn",
    "optional": "Optional",
    "claim_initial_territory_medal": "Claim initial territory medal",
    "claimable_rewards": "Claimable Rewards",
    "taiwan_resident_pass": "Taiwan Resident Pass",
    "top_right_close_button": "Top Right Close Button",
    "right_side": "Right Side",
    "right_price_button": "Right Price Button",
    "right_content": "Right Content",
    "right_area": "Right Area",
    "right_icon": "Right Icon",
    "right_display": "Right Display",
    "right_invited_info": "Right Invited Info",
    "right_button": "Right Button",
    "right_revenue_card": "Right Revenue Card",
    "right_text_part": "Right Text Part",
    "right_column": "Right Column",
    "number": "Number",
    "cooperation_location": "Cooperation Location",
    "cooperation_square": "Cooperation Square",
    "cooperation_poster": "Cooperation Poster",
    "cooperation_detail": "Cooperation Detail",
    "hopson_one": "Hopson One",
    "total_sum": "Total",
    "same_day_available": "Same day available",
    "agree_protocol_register": "Agree protocol and register",
    "agree_recharge": "Agree and recharge",
    "agree_continue": "Agree and continue",
    "peers": "Peers",
    "no_politics_in_name": "No politics in name",
    "name_tags_area": "Name and Tags Area",
    "people_checked_in": "checked in",
    "after": "After",
    "apply_after_sales_again_after": "Apply after-sales again after",
    "merchant_not_confirm_after_reapply": "Merchant not confirm after reapply",
    "merchant_not_confirm_after": "Merchant not confirm after",
    "merchant_not_refund_after": "Merchant not refund after",
    "return_prev_page_after": "Return to previous page after",
    "open_after": "Open after",
    "revoke_return_if_not_shipped_after": "Revoke return application if not shipped after",
    "potential_refund_later": "Potential refund situation for subsequent users",
    "auto_close_after": "Auto close after",
    "upward_gradient_shadow": "Upward Gradient Shadow",
    "show_code_to_merchant": "Show code or coupon to merchant to consume",
    "question_mark": "?",
    "else_show_back_arrow": "Else show back arrow",
    "startup_success": "Startup Success",
    "bottom_cancel_button": "Bottom Cancel Button",
    "monday": "Monday",
    "wednesday": "Wednesday",
    "tuesday": "Tuesday",
    "friday": "Friday",
    "saturday": "Saturday",
    "thursday": "Thursday",
    "years_old": "Years Old",
    "sunday": "Sunday",
    "and": "And",
    "and_miniapp": "And MiniProgram",
    "unified_with_miniapp": "Unified with MiniProgram",
    "coffee_lover": "Coffee Lover",
    "brand_intro": "Brand Intro",
    "brand_collab_opportunity": "Brand Collab Opportunity",
    "brand_recommender": "Brand Recommender",
    "brand_apply_collab": "Brand Apply Collab",
    "after_sales_processing": "After-sales Processing",
    "after_sales_desc": "After-sales Description",
    "after_sales_info_modal": "After-sales Info Modal",
    "after_sales_no": "After-sales No",
    "after_sales_product_modal": "After-sales Product Modal",
    "after_sales_button": "After-sales Button",
    "after_sales_description": "After-sales Description",
    "after_sales_desc_input_modal": "After-sales Description Input Modal",
    "worry_free_after_sales": "Worry-free After-sales",
    "after_sales_status_hint": "After-sales Status Hint",
    "after_sales_reason": "After-sales Reason",
    "after_sales_reason_modal": "After-sales Reason Modal",
    "after_sales_apply_failed": "After-sales Apply Failed",
    "after_sales_apply_submitted": "After-sales Apply Submitted",
    "after_sales_type": "After-sales Type",
    "after_sales_detail": "After-sales Detail",
    "after_sales_options": "After-sales Options",
    "product": "Product",
    "product_info": "Product Info",
    "product_info_incomplete": "Product Info Incomplete",
    "product_info_area": "Product Info Area",
    "product_info_card": "Product Info Card",
    "product_info_error": "Product Info Error",
    "product_share_card": "Product Share Card",
    "product_list": "Product List",
    "product_card": "Product Card",
    "product_card_template": "Product Card Template",
    "product_name": "Product Name",
    "product_image_list": "Product Image List",
    "product_image": "Product Image",
    "product_image_area": "Product Image Area",
    "product_image_carousel": "Product Image Carousel",
    "product_basic_info": "Product Basic Info",
    "product_off_shelf": "Product Off Shelf",
    "product_invalid": "Product Invalid",
    "product_quantity": "Product Quantity",
    "product_quantity_min": "Product Quantity Minimum",
    "product_exposure": "Product Exposure",
    "product_tags": "Product Tags",
    "product_title": "Product Title",
    "product_grid": "Product Grid",
    "product_specs": "Product Specs",
    "product_detail": "Product Detail",
    "product_amount": "Product Amount",
    "merchant": "Merchant",
    "merchant_name": "Merchant Name",
    "merchant_invite_user": "Merchant Invite User",
    "merchant_reject": "Merchant Reject",
    "merchant_rejected_after_sales": "Merchant Rejected After-sales",
    "merchant_rejected_refund": "Merchant Rejected Refund",
    "merchant_no_product_yet": "Merchant Has No Product Yet",
    "merchant_auth": "Merchant Auth",
    "merchant_invited_merchant": "Merchant Invited Merchant",
    "merchant_invited_user": "Merchant Invited User",
    "business": "Business",
    "business_name": "Business Name",
    "business_location": "Business Location",
    "business_invite_card": "Business Invite Card",
    "business_territory": "Business Territory",
    "sichuan": "Sichuan",
    "follow_back": "Follow Back",
    "back_to_map": "Back to Map",
    "back_to_map_button": "Back to Map Button",
    "back_to_territory": "Back to Territory",
    "reply": "Reply",
    "replied_your_comment": "Replied to your comment",
    "reply_success": "Reply Success",
    "reply_comment": "Reply Comment",
    "reply_input": "Reply Input",
    "callback_failed": "Callback Failed",
    "group": "Group",
    "group_buy": "Group Buy",
    "group_buy_coupon": "Group Buy Coupon",
    "group_buy_center": "Group Buy Center",
    "group_buy_product_detail": "Group Buy Product Detail",
    "group_buy_detail": "Group Buy Detail",
    "group_buy_product": "Group Buy Product",
    "group_buy_product_detail_alt": "Group Buy Product Detail",
    "group_buy_combo": "Group Buy Combo",
    "group_buy_write_off": "Group Buy Write-off",
    "group_buy_detail_alt": "Group Buy Detail",
    "team_admin": "Team Admin",
    "fixed": "Fixed",
    "fix_use_first_image": "Fixed Use First Image",
    "fix_at_top": "Fixed at Top",
    "fixed_size": "Fixed Size",
    "events_plaza": "Events Plaza",
    "all_activities": "All Activities",
    "same_city": "Same City",
    "hot": "Hot",
    "no_activities": "No Activities",
    "signup_success_msg": "Congratulations on successfully signing up for the activity. Please participate on time. You can view details in [My] - [My Activities]",
    "fixed_term": "Fixed Term",
    "icon": "Icon",
    "image": "Image",
    "image_upload_area": "Image Upload Area",
    "image_load_failed": "Image Load Failed",
    "image_area": "Image Area",
    "image_saved_to_album": "Image Saved to Album",
    "image_data_empty": "Image Data Empty",
    "image_count_badge": "Image Count Badge",
    "image_index_indicator": "Image Index Indicator",
    "image_crop_failed": "Image Crop Failed",
    "image_counter": "Image Counter",
    "image_carousel_alt": "Image Carousel",
    "arc_progress_bar": "Arc Progress Bar",
    "ring_chart": "Ring Chart",
    "rounded_corners": "Rounded Corners",
    "tuqi_group_made": "Made by Tuqi Group",
    "at": "At",
    "online_status": "Online Status",
    "in_territory": "In Territory",
    "follow_find_me_in_territory": "Follow and find me in Territory",
    "region": "Region",
    "region_selector": "Region Selector",
    "region_picker_modal": "Region Picker Modal",
    "map": "Map",
    "map_load_failed": "Map Load Failed",
    "map_container": "Map Container",
    "address_info": "Address Info",
    "modify_address_alt": "Modify Address",
    "switch_address_delivery": "Switch Address and Delivery",
    "select_address_delivery": "Select Address and Delivery",
    "address_management": "Address Management",
    "address_type": "Address Type",
    "offline_gathering": "Offline Gathering",
    "city": "City",
    "city_list": "City List",
    "city_level": "City Level",
    "base_init_completed": "Base Init Completed",
    "fill_tracking_no": "Fill Tracking No",
    "fill_account_info": "Fill Account Info",
    "fill_shipping_address": "Fill Shipping Address",
    "fill_id_info": "Fill ID Info",
    "fill_return_logistics": "Fill Return Logistics",
    "process": "Process",
    "processing": "Processing",
    "handle_yyb_download": "Handle MyApp Download",
    "handle_honor_download": "Handle Honor Download",
    "backup": "Backup",
    "icp_license": "ICP License",
    "backup_tag_failed": "Backup Tag Failed",
    "backup_tag_success": "Backup Tag Success",
    "copy": "Copy",
    "copy_usage_comment": "Copy to use, please keep this comment",
    "copy_failed": "Copy Failed",
    "copy_miniapp_link_failed": "Copy MiniProgram Link Failed",
    "copy_success": "Copy Success",
    "copy_invite_code": "Copy Invite Code",
    "copy_invite_code_failed": "Copy Invite Code Failed",
    "copy_link": "Copy Link",
    "copy_territory_link_download": "Copy Territory Link to Download",
    "delivery_available": "Delivery Available",
    "foreigner_residence_permit": "Foreigner Residence Permit",
    "outer_container": "Outer Container",
    "outer_container_style": "Outer container controls max/min height and bg padding",
    "takeout": "Takeout",
    "multiple_avatars": "Multiple Avatars",
    "greater_than": "Greater Than",
    "lucky_prosperous": "Lucky and Prosperous",
    "day": "Day",
    "valid_within_days": "Valid within days",
    "days_ago": "days ago",
    "expire_after_days": "Expire after days",
    "valid_after_days": "Valid after days",
    "daily_checkin": "Daily Check-in",
    "daily_checkin_reward": "Daily Check-in Reward",
    "day_reward": "Day Reward",
    "day_revenue_curve": "Day Revenue Curve",
    "days_count": "Days Count",
    "days_valid": "Days Valid",
    "tianjin_city": "Tianjin",
    "scorpio": "Scorpio",
    "sold_out_in_days": "Sold out in days",
    "suncode_load_failed": "SunCode Load Failed",
    "suncode_display_area": "SunCode Display Area",
    "suncode_loading": "SunCode Loading",
    "invalid": "Invalid",
    "invalid_product": "Invalid Product",
    "invalid_status_icon": "Invalid Status Icon",
    "invalid_status_mask": "Invalid Status Mask",
    "failed": "Failed",
    "avatar": "Avatar",
    "avatar_info": "Avatar Info",
    "avatar_stroke": "Avatar Stroke",
    "avatar_update_failed": "Avatar Update Failed",
    "avatar_not_loaded": "Avatar Not Loaded",
    "avatar_frame": "Avatar Frame",
    "avatar_frame_display": "Avatar Frame Display",
    "avatar_frame_buy_modal": "Avatar Frame Buy Modal",
    "avatar_section": "Avatar Section",
    "header_image_area": "Header Image Area",
    "header": "Header",
    "header_bg_image": "Header BG Image",
    "reward_modal": "Reward Modal",
    "female": "Female",
    "friend_buys_you_earn": "Friend buys, you earn",
    "praise": "Praise",
    "praise_rank": "Praise Rank",
    "if_example": "If",
    "submit_gitee_if_suggestion": "If you have suggestions, please submit to Gitee",
    "if_need_join_store": "If you need to join store",
    "if_has": "If has",
    "if_has_input": "If has input",
    "if_no_input": "If no input",
    "invoice_contact_offline": "If you need invoice, please contact shop staff offline",
    "full_name": "Full Name",
    "submenu_list": "Submenu List",
    "font_loading_completed_alt": "Font Loading Completed",
    "font_loading_mask": "Font Loading Mask",
    "string_format": "String Format",
    "full_replace": "Full Replace",
    "complete_avatar": "Complete Avatar",
    "complete_account_info": "Complete Account Info",
    "complete_shipping_address_hint": "Complete Your Shipping Address",
    "complete_shipping_address": "Complete Shipping Address",
    "completed": "Completed",
    "complete_below_actions": "Complete Below Actions",
    "after_realname_auth": "After Realname Auth",
    "completion_rate": "Completion Rate",
    "full_init_completed": "Full Init Completed",
    "full_modal": "Full Modal",
    "full_ranking": "Full Ranking",
    "official": "Official",
    "official_website": "Official Website",
    "positioning": "Positioning",
    "positioning_failed": "Positioning Failed",
    "positioning_success": "Positioning Success",
    "positioning_placeholder": "Positioning Placeholder",
    "actual_payment": "Actual Payment",
    "physical_group_buy_detail": "Physical Group Buy Detail",
    "physical_retail_detail": "Physical Retail Detail",
    "live_photo": "Live Photo",
    "realname_auth": "Realname Auth",
    "solid_star": "Solid Star",
    "realtime_selected_time": "Realtime Selected Time",
    "realtime_speed": "Realtime Speed",
    "physical": "Physical",
    "physical_coupon": "Physical Coupon",
    "physical_goods": "Physical Goods",
    "physical_group_goods": "Physical Group Goods",
    "physical_retail_goods": "Physical Retail Goods",
    "implement_pull_refresh_load": "Implement Pull Refresh and Load More",
    "auditing": "Auditing",
    "audit_result_notify": "Audit result will be notified via system message",
    "customer_service": "Customer Service",
    "customer_service_card": "Customer Service Card",
    "family": "Family",
    "capacity_select": "Capacity Select",
    "corresponding_benefits": "Corresponding Benefits",
    "object_empty": "Object Empty",
    "navigation": "Navigation",
    "nav_position_error": "Navigation Position Error",
    "nav_failed": "Navigation Failed",
    "navbar": "Navbar",
    "navbar_main": "Navbar Main",
    "navbar_content_area": "Navbar Content Area",
    "will_at": "Will at",
    "will_use": "Will use",
    "will_auto_agree_after_sales": "Will auto agree after-sales",
    "will_auto_refund": "Will auto refund",
    "will_auto_refund_to_you": "Will auto refund to you",
    "small_avatar": "Small Avatar",
    "hour": "Hour",
    "ship_within_hours": "Ship within hours",
    "hours_ago": "hours ago",
    "expire_after_hours": "Expire after hours",
    "refund_after_hours": "Refund after hours",
    "sold_out_in_hours": "Sold out in hours",
    "miniapp": "MiniProgram",
    "miniapp_dedicated": "MiniProgram Dedicated",
    "miniapp_code": "MiniProgram Code",
    "miniapp_link_empty": "MiniProgram Link Empty",
    "miniapp_link_copied": "MiniProgram Link Copied",
    "miniapp_color_extract_failed": "MiniProgram Color Extract Failed",
    "miniapp_color_extract_incomplete": "MiniProgram Color Extract Incomplete",
    "try_further_batching": "Try further batching",
    "try_downgrade": "Try downgrade",
    "claim_limited_identity_hint": "to claim limited digital identity",
    "render_open_tag_when_ready": "Render open tag when ready",
    "game_round": "Round",
    "local_care": "Local Care",
    "floor_food_court": "Floor Food Court",
    "expand": "Expand",
    "expand_collapse_button": "Expand/Collapse Button",
    "expand_more_button": "Expand More Button",
    "show_bottom_button_placeholder": "Show Bottom Button Placeholder",
    "attr_show_search_box": "Attr Show Search Box",
    "attr_add_fixed_class_style": "Attr Add Fixed Class Style",
    "attr_set_home": "Attr Set Home",
    "mountain_chart": "Mountain Chart",
    "left_side": "Left Side",
    "left_area": "Left Area",
    "left_brand_card": "Left Brand Card",
    "left_product_thumb": "Left Product Thumb",
    "left_image": "Left Image",
    "left_avatar": "Left Avatar",
    "left_hint_text": "Left Hint Text",
    "left_amount": "Left Amount",
    "left_column": "Left Column",
    "uploaded_images": "Uploaded Images",
    "off_shelf": "Off Shelf",
    "order_generated": "Order Generated",
    "order_generated_simple": "Order Generated",
    "paid": "Paid",
    "used": "Used",
    "used_status": "Used Status",
    "followed": "Followed",
    "closed": "Closed",
    "received_payment": "Payment Received",
    "added_to_showcase": "Added to Showcase",
    "added_to_cart": "Added to Cart",
    "added_to_selection": "Added to Selection Library",
    "added_showcase_short": "Added Showcase",
    "all_data_loaded": "All Data Loaded",
    "added_selection_short": "Added Selection",
    "sent_to": "Sent to",
    "cancelled": "Cancelled",
    "cancelled_remove": "Cancelled Remove",
    "cancelled_top": "Cancelled Top",
    "cancelled_default": "Cancelled Default",
    "sold": "Sold",
    "after_sold": "After Sold",
    "sold_quantity": "Sold Quantity",
    "already_in": "Already In",
    "copied_to_clipboard": "Copied to Clipboard",
    "expired": "Expired",
    "expired_status": "Expired Status",
    "deposited_to_wallet": "Deposited to Wallet",
    "completed_status": "Completed",
    "sale_started": "Sale Started",
    "store_opened": "Store Opened",
    "territory_deleted_success": "Territory Deleted Successfully",
    "signed_up": "Signed Up",
    "refused": "Refused",
    "holding": "Holding",
    "collected": "Collected",
    "paid_status": "Paid",
    "received_goods": "Goods Received",
    "applied_after_sales": "Applied After-sales",
    "when_logged_in": "When Logged In",
    "signed": "Signed",
    "signed_for": "Signed For",
    "already_hold_digital_goods": "Already hold this digital good",
    "consecutive_checkin_days": "Consecutive check-in days",
    "settled": "Settled",
    "obtained": "Obtained",
    "obtained_avatar_frame": "Obtained Avatar Frame",
    "decoded": "Decoded",
    "already_set_as_default": "Set as Default",
    "reminder_set": "Reminder Set",
    "share_invoked": "Share Invoked",
    "max_upload_limit_reached": "Max upload limit reached",
    "consecutive_checkin": "Consecutive Check-in",
    "refunded": "Refunded",
    "already_selected": "Selected",
    "selected_region_display": "Selected Region Display",
    "estimated_commission_from_promotion": "Estimated commission from promotion",
    "invited": "Invited",
    "invited_users": "Invited Users",
    "store_closed": "Store Closed",
    "read_and_agreed": "Read and Agreed",
    "reserved": "Reserved",
    "claimed": "Claimed",
    "defaulted": "Defaulted",
    "city_suffix": "City",
    "layout_error": "Layout Error",
    "bring_revenue": "Bring Revenue",
    "with_blur_bg": "With Blur BG",
    "with_white_border": "With White Border",
    "promoting_sales_volume": "Sales Volume",
    "with_mask_effect": "With Mask Effect",
    "help_write_station": "Help Write Station",
    "help_promote_brand": "Help promote your favorite brand",
    "common_cities": "Common Cities",
    "common_tools": "Common Tools",
    "common_is": "Common is",
    "year": "Year",
    "yearly_sales": "Yearly Sales",
    "strict_protection": "and will be strictly protected",
    "and_earn_commission": "and earn commission",
    "and_claim_reward": "and claim reward",
    "guangdong_province": "Guangdong",
    "square": "Square",
    "guangzhou_city": "Guangzhou",
    "serialize_failed": "Serialize Failed",
    "stock": "Stock",
    "lib_replace_self": "Lib Replace Self",
    "yyb_download_failed": "MyApp Download Failed",
    "footer_info": "Footer Info",
    "footer_info_area": "Footer Info Area",
    "footer_common": "Footer Common",
    "footer_area": "Footer Area",
    "footer_fixed_profile": "Footer Fixed Profile",
    "bottom_modal": "Bottom Modal",
    "bottom_modal_content": "Bottom Modal Content",
    "bottom_button": "Bottom Button",
    "bottom_action_button": "Bottom Action Button",
    "bottom_action_bar": "Bottom Action Bar",
    "bottom_pay_button": "Bottom Pay Button",
    "bottom_label_container": "Bottom Label Container",
    "bottom_gradient_mask": "Bottom Gradient Mask",
    "bottom_settlement": "Bottom Settlement",
    "bottom_settlement_bar": "Bottom Settlement Bar",
    "bottom_comment_input": "Bottom Comment Input",
    "bottom_explain_text": "Bottom Explain Text",
    "bottom_buy_button": "Bottom Buy Button",
    "shop_available": "Shop Available",
    "shop_info": "Shop Info",
    "shop_info_order_status": "Shop Info and Order Status",
    "shop_share_card": "Shop Share Card",
    "shop_share_modal": "Shop Share Modal",
    "shop_list": "Shop List",
    "shop_name": "Shop Name",
    "shop_return_rate_high": "Shop Return Rate High",
    "shop_preparing": "Shop Preparing",
    "shop_home": "Shop Home",
    "enable": "Enable",
    "start": "Start",
    "start_minute": "Start Minute",
    "start_init_download": "Start Init Download",
    "start_loading_fonts": "Start Loading Fonts",
    "start_hour": "Start Hour",
    "start_time": "Start Time",
    "account_opened_success": "Account Opened Success",
    "bank_card_number": "Bank Card Number",
    "bank_address": "Bank Address",
    "opening_bank": "Opening Bank",
    "open_for_purchase": "Open for Purchase",
    "open_source_address": "Open Source Address",
    "opening": "Opening",
    "open_brand_new_stronghold": "Open a brand new stronghold for your brand",
    "open_withdrawable": "Open Withdrawable",
    "open_claim_digital_assets": "Claim digital assets after opening",
    "open_digital_wallet": "Open Digital Wallet",
    "open_date": "Open Date",
    "guide_content": "Guide Content",
    "sheet": "Sheet",
    "coupons_available_count": "Coupons Available Count",
    "images_count": "Images Count",
    "popup_content": "Popup Content",
    "popup_layer": "Popup Layer",
    "danmu_track": "Danmu Track",
    "dialog_box": "Dialog Box",
    "modal": "Modal",
    "modal_content": "Modal Content",
    "modal_header": "Modal Header",
    "when_disabled": "When Disabled",
    "current": "Current",
    "current_is_not": "Current is not",
    "current_location": "Current Location",
    "current_balance": "Current Balance",
    "balance_insufficient_purchase_hint": "Insufficient balance, please recharge diamond to purchase",
    "merchant_invited_by_another": "Mechant invited by another merchant",
    "screenshot_not_supported": "Screenshot not supported in current environment",
    "bridge_not_supported": "Bridge not supported in current environment",
    "current_user": "Current User",
    "current_user_tag": "Current User Tag",
    "when_enabled": "When Enabled",
    "pending_payment": "Pending Payment",
    "pending_use": "Pending Use",
    "pending_ticket": "Pending Ticket",
    "pending_seller_delivery": "Pending Seller Delivery",
    "pending_seller_accept": "Pending Seller Accept",
    "pending_shipment": "Pending Shipment",
    "pending_merchant_confirm": "Pending Merchant Confirm",
    "pending_merchant_confirm_refund_only": "Pending Merchant Confirm (Refund Only)",
    "pending_merchant_confirm_return_refund": "Pending Merchant Confirm (Return & Refund)",
    "pending_merchant_refund": "Pending Merchant Refund",
    "pending_fill_logistics": "Pending Fill Logistics",
    "pending_audit": "Pending Audit",
    "pending_open_store": "Pending Open Store",
    "pending_pickup": "Pending Pickup",
    "pending_pay": "Pending Pay",
    "pending_receipt": "Pending Receipt",
    "pending_settlement": "Pending Settlement",
    "pending_settlement_amount": "Pending Settlement Amount",
    "pending_evaluation": "Pending Evaluation",
    "pending_claim": "Pending Claim",
    "very_satisfied": "Very Satisfied",
    "regret": "Regret",
    "nice_to_meet_everyone": "Nice to meet everyone",
    "wechat": "WeChat",
    "wechat_one_click_login": "WeChat One-click Login",
    "wechat_share_thumb": "WeChat Share Thumb",
    "wechat_share_thumb_component": "WeChat Share Thumb Component",
    "wechat_friend": "WeChat Friend",
    "miniapp_share_cover_generator": "MiniProgram Share Cover Generator",
    "miniapp_share_thumb": "MiniProgram Share Thumb",
    "miniapp_map_not_supported": "Map not supported in MiniProgram",
    "wechat_promote": "WeChat Promote",
    "wechat_pay": "WeChat Pay",
    "wechat_env_hint": "WeChat Env Hint",
    "wechat_login_failed": "WeChat Login Failed",
    "wechat_config_init": "WeChat Config Init",
    "required_param_missing": "Required Param Missing",
    "pizza_hotpot": "Pizza Hotpot",
    "go_post_memory": "Go post to remember",
    "go_check_it_out": "Go check it out",
    "explore_new_world_in_territory": "Go explore new world in Territory",
    "come_join_territory": "Come join Territory",
    "come_chat_with_me": "Come chat with me",
    "come_check_it_out": "Come check it out",
    "express_info_header": "Express Info Header",
    "tracking_number": "Tracking Number",
    "express_logistics_info": "Express Logistics Info",
    "express_order": "Express Order",
    "express_delivery": "Express Delivery",
    "gender": "Gender",
    "gender_age_zodiac_tags": "Gender Age Zodiac Tags",
    "gender_age_tags": "Gender Age Tags",
    "total_value": "Total Value",
    "total_count": "Total",
    "total_amount": "Total Amount",
    "congrats": "Congrats",
    "congrats_fortune": "Congrats Fortune",
    "congrats_you": "Congrats You",
    "congrats_become_nth": "Congrats Become Nth",
    "congrats_signup_success": "Congrats Signup Success",
    "congrats_obtain": "Congrats Obtain",
    "congrats_unlock_achievement": "Congrats Unlock First Week Achievement",
    "congrats_first_checkin": "Congrats First Check-in",
    "you_can_repay": "You can repay",
    "you_joined_showcase": "You joined showcase",
    "you_joined_selection": "You joined selection",
    "you_applied_refund": "You applied refund",
    "you_revoked_after_sales": "You revoked after-sales",
    "you_applied_refund_simple": "You applied refund",
    "you_passed_territory_auth": "You passed territory auth",
    "you_currently_have": "You currently have",
    "you_have": "You have",
    "your": "Your",
    "your_referrer_is": "Your referrer is",
    "your_info_usage": "Your info only used for above purpose",
    "your_info_protected": "Your info will be strictly encrypted and protected",
    "your_account_info_error": "Your account info error",
    "your_led_balance_insufficient": "Your LED balance insufficient",
    "your_lzd_balance_insufficient": "Your LZD balance insufficient",
    "you_cannot_withdraw_yet": "You cannot withdraw yet",
    "you_not_bind_phone": "You not bind phone",
    "you_selected_too_many_tags": "You selected too many tags",
    "surprise_double": "Surprise Double",
    "surprise_red_packet": "Surprise Red Packet",
    "thanks_support_opensource": "Thanks for supporting opensource",
    "become_distributor": "Become Distributor",
    "sales_volume_rank": "Sales Volume Rank",
    "transaction_amount": "Transaction Amount",
    "success_join_territory": "Successfully joined a Territory",
    "member_alt": "Member",
    "member_list": "Member List",
    "member_center": "Membership Center",
    "member_center_default_card": "Membership Card",
    "member_rights": "Member Benefits",
    "member_rights_count_suffix": " benefits",
    "member_code": "Member Code",
    "member_verification_code": "Member Verification Code",
    "member_mine": "My",
    "member_increase": "Member Increase",
    "member_action": "Member Action",
    "chengdu_city": "Chengdu",
    "growth": "Growth",
    "growth_value": "Growth Value",
    "me": "Me",
    "i_want_auth": "I want auth too",
    "we_will_auto_register": "We will auto register for you",
    "we_need_realname_auth": "We need realname auth",
    "i_joined": "I joined",
    "i_joined_adj": "I joined",
    "i_promoting_in_territory": "I am promoting brand in Territory",
    "i_hold_digital_assets": "Digital assets I hold",
    "i_am": "I am",
    "i_am_here": "I am here",
    "my": "My",
    "my_card_pack": "My Card Pack",
    "my_qrcode": "My QR Code",
    "my_coupons": "My Coupons",
    "my_nft": "My NFT",
    "my_member_points": "My Points",
    "monthly_exclusive_coupon": "Monthly Coupon",
    "all_discount_offer": "20% Off Storewide",
    "points_reward": "Points Reward",
    "exclusive_event": "Exclusive Event",
    "birthday_exclusive_gift": "Birthday Gift Pack",
    "open_membership_now": "Open Now",
    "my_follows": "My Follows",
    "my_moments": "My Moments",
    "my_addresses": "My Addresses",
    "my_digital_assets": "My Digital Assets",
    "my_tags": "My Tags",
    "my_activities": "My Activities",
    "my_fans": "My Fans",
    "my_orders": "My Orders",
    "membership_card_order": "Membership Orders",
    "membership_card_usage_record": "Membership Usage Record",
    "membership_validity": "Membership Validity",
    "member_card_points": "Membership Points",
    "membership_number": "Membership Number",
    "my_selection_library": "My Selection Library",
    "my_wallet": "My Wallet",
    "nft_digital_asset_order": "NFT Asset Orders",
    "invitation_record": "Invitation Record",
    "view_points_detail": "View point details",
    "view_coupon_pack": "View coupon pack",
    "please_show_qr_to_staff": "Please show the QR code to staff for scanning",
    "qr_refresh_after_scan": "The QR code will refresh immediately after each scan",
    "qr_auto_refresh": "The QR code will refresh automatically in {seconds}s",
    "other_benefits": "Other Benefits",
    "purchase_notice": "Purchase Notice",
    "actual_payment": "Actual Payment",
    "tap_for_details": "Tap for details",
    "feature_coming_soon": "Coming Soon",
    "my_lzd": "My LZD",
    "i_know": "I know",
    "i_want_auth_merchant": "I want to be merchant",
    "i_invited": "I invited",
    "i_earned_a_lot": "I earned a lot",
    "i_earned_a_lot_full": "I earned a lot!",
    "or_buy_via_link": "or buy via shared link",
    "or": "Or",
    "screenshot_failed": "Screenshot Failed",
    "screenshot_gen_failed": "Screenshot Generation Failed",
    "screenshot_error": "Unknown Error During Screenshot",
    "click_link_get_coupon": "Click link get coupon",
    "location_place": "Location Place",
    "location_region": "Location Region",
    "belong_merchant": "Belong Merchant",
    "all_fonts_loaded_alt": "All fonts loaded",
    "all_batch_events_passed": "All batch events passed",
    "manually_extracted": "Manually Extracted",
    "manual_parse": "Manual Parse",
    "manual_decode": "Manual Decode",
    "manual_trigger_download": "Manual Trigger Download",
    "mobile_number": "Mobile Number",
    "phone_number": "Phone Number",
    "only_then_can_send_red_packet": "Only then can send red packet on map",
    "pack_pickup": "Pack Pickup",
    "open": "Open",
    "build_digital_ecology": "Build your own digital ecology",
    "tax_deduction_rules": "Tax Deduction Rules",
    "scan": "Scan",
    "scan_qrcode": "Scan QR Code",
    "scan_button": "Scan Button",
    "scan_find_me": "Scan to find me in MiniProgram",
    "batch_send_failed": "Batch Send Failed",
    "batch_send_exception": "Batch Send Exception",
    "batch_send_success": "Batch Send Success",
    "batch_request_timeout": "Batch Request Timeout",
    "batch": "Batch",
    "batch_event_passed": "Batch Event Passed",
    "batch_add_showcase": "Batch Add Showcase",
    "batch_send_failed_alt": "Batch Send Failed",
    "batch_send_exception_alt": "Batch Send Exception",
    "cabinet_or_station": "Cabinet or Station Receive",
    "cabinet_or_station_alt": "Cabinet or Station",
    "discount": "Discount",
    "line_chart": "Line Chart",
    "grab_red_packet_agree": "Grab red packet means agree",
    "rush_buy": "Rush Buy",
    "passport": "Passport",
    "signup_info": "Signup Info",
    "signup_info_modal": "Signup Info Modal",
    "signup_participate": "Signup Participate",
    "signup_failed": "Signup Failed",
    "signup_success": "Signup Success",
    "signup_detail": "Signup Detail",
    "block": "Block",
    "block_success": "Block Success",
    "reject_reason": "Reject Reason",
    "reject_time": "Reject Time",
    "access_denied": "Access Denied",
    "own": "Own",
    "try_luck": "Try Luck",
    "upload_holder_id": "Upload Holder ID",
    "hold": "Hold",
    "holder": "Holder",
    "holder_count": "Holder Count",
    "after_holding": "After Holding",
    "hold_digital_product": "Hold Digital Product",
    "after_holding_digital_product": "After Holding Digital Product",
    "hold_digital_asset": "Hold Digital Asset",
    "hold_digital_identity": "Hold Digital Identity",
    "hold_data": "Hold Data",
    "held_digital_assets": "Held Digital Assets",
    "holder_alt": "Holder",
    "holder_revenue": "Holder Revenue",
    "hold_territory_identity": "Hold Territory Identity",
    "within_designated_period": "Within Designated Period",
    "by_commission": "By Commission",
    "button": "Button",
    "button_element_not_found": "Button Element Not Found",
    "button_group_render": "Button Group Render",
    "by_sales": "By Sales",
    "try_another_network": "Try another network",
    "explore_journey_start": "Explore journey official start",
    "promotion_alt": "Promotion",
    "promotion_tool": "Promotion Tool",
    "promotion_record": "Promotion Record",
    "promote_earn_cash": "Promote Earn Cash",
    "promote_navigator": "Promote Navigator",
    "recommend": "Recommend",
    "recommend_others_buy": "Recommend Others Buy",
    "recommend_use": "Recommend Use",
    "recommend_content_list": "Recommend Content List",
    "recommend_alliance": "Recommend Alliance",
    "recommend_page": "Recommend Page",
    "recommend_territory": "Recommend Territory",
    "description_text": "Description Text",
    "description_input_area": "Description Input Area",
    "submit": "Submit",
    "submitting": "Submitting",
    "audit_after_submit": "Enter audit after submit",
    "submit_success": "Submit Success",
    "submit_button": "Submit Button",
    "upgrade_personal_level": "Upgrade your personal level",
    "extract_image_color_failed": "Extract Image Color Failed",
    "withdraw": "Withdraw",
    "withdraw_commission": "Withdraw Commission",
    "withdraw_success": "Withdraw Success",
    "withdraw_apply": "Withdraw Apply",
    "hint": "Hint",
    "hint_text": "Hint Text",
    "hint_content": "Hint Content",
    "hint_page": "Hint Page",
    "plugin_market_url": "Plugin Market URL",
    "search": "Search",
    "search_placeholder": "Search Placeholder",
    "search_history": "Search History",
    "search_icon": "Search Icon",
    "search_place": "Search Place",
    "search_shop": "Search Shop",
    "search_box": "Search Box",
    "search_box_mode": "Search Box Mode",
    "search_box_click": "Search Box Click",
    "search_input": "Search Input",
    "search_territory": "Search Territory",
    "select_territory": "Select Territory",
    "please_select_territory": "Please Select Territory",
    "no_territory_found": "No Territory Found",
    "camera_no_permission": "Camera no permission or cannot get camera data",
    "revoke_after_sales": "Revoke After-sales",
    "revoke_after_sales_failed": "Revoke After-sales Failed",
    "revoke_after_sales_success": "Revoke After-sales Success",
    "revoke_time": "Revoke Time",
    "operating": "Operating",
    "operation_loading": "Operation Loading",
    "operation_failed": "Operation Failed",
    "operation_button": "Operation Button",
    "operation_button_area": "Operation Button Area",
    "paying": "Paying",
    "payment_countdown": "Payment Countdown",
    "payment_dev_in_progress": "Payment Dev In Progress",
    "after_payment": "After Payment",
    "cancel_after_payment": "Cancel After Payment",
    "payment_failed": "Payment Failed",
    "alipay": "Alipay",
    "alipay_miniapp": "Alipay MiniProgram",
    "payment_modal": "Payment Modal",
    "payment_success": "Payment Success",
    "payment_method": "Payment Method",
    "payment_method_select": "Payment Method Select",
    "payment_serial_no": "Payment Serial No",
    "payment_result": "Payment Result",
    "payment_amount": "Payment Amount",
    "expenditure": "Expenditure",
    "income_expenditure_detail": "Income and Expenditure Detail",
    "support": "Support",
    "support_slot": "Support Slot",
    "recipient": "Recipient",
    "recipient_info": "Recipient Info",
    "income": "Income",
    "revenue": "Revenue",
    "revenue_rank": "Revenue Rank",
    "revenue_curve": "Revenue Curve",
    "revenue_tag": "Revenue Tag",
    "revenue_rate": "Revenue Rate",
    "close_market": "Close Market",
    "collection_total_value": "Collection Total Value",
    "receiver": "Receiver",
    "receive_place": "Receive Place",
    "shipping_address": "Shipping Address",
    "shipping_address_info": "Shipping Address Info",
    "collapse": "Collapse",
    "put_store_poster": "Put into store poster",
    "scatter_chart": "Scatter Chart",
    "count": "Count",
    "digital_product_purchase_notice": "Digital Product Purchase Notice",
    "digital_member_card": "Digital Member Card",
    "digital_member_promote": "Digital Member Promote",
    "digital_product": "Digital Product",
    "digital_exhibition": "Digital Exhibition",
    "digital_asset_wallet": "Digital Asset Wallet",
    "how_to_buy_digital_assets": "How to buy digital assets",
    "what_use_digital_assets": "What's the use of digital assets",
    "digital_assets_order": "Digital Assets Order",
    "digital_equity_token": "Digital Equity Token",
    "digital_collection": "Digital Collection",
    "digital_asset_equity": "Digital Asset Equity",
    "digital_asset_holding": "Digital Asset Holding and Accumulation",
    "digital_asset_msg": "Digital Asset Message",
    "digital_asset_order": "Digital Asset Order",
    "data": "Data",
    "data_empty": "Data Empty",
    "data_load_failed": "Data Load Failed",
    "data_format_error": "Data Format Error",
    "data_type_error": "Data Type Error",
    "data_error_exception": "Data Error or Exception",
    "data_must_be": "Data must be",
    "digital_asset_total_value": "Digital Asset Total Value",
    "digital_asset_count": "Digital Asset Count",
    "file": "File",
    "file_size_exceed": "File size cannot exceed",
    "file_too_small": "File too small",
    "file_failed": "File Failed",
    "file_format": "File Format",
    "new_world": "New World",
    "newcomer_report": "Newcomer Report",
    "new_product": "New Product",
    "new_product_tag": "New Product Tag",
    "add_shipping_address": "Add Shipping Address",
    "create_address": "Create Address",
    "novice_navigator": "Novice Navigator",
    "new_retail_detail": "New Retail Detail",
    "method": "Method",
    "invalid_number": "Invalid Number",
    "invalid_adj": "Invalid",
    "invalid_hex_color": "Invalid Hex Color",
    "invalid_sale_time": "Invalid Sale Time",
    "no_data": "No Data",
    "upload_image_failed": "Upload Image Failed",
    "create_failed": "Create Failed",
    "copy_failed_alt": "Copy Failed",
    "copy_link_failed": "Copy Link Failed",
    "login_failed": "Login Failed",
    "obtain_failed": "Obtain Failed",
    "obtain_user_info_failed": "Failed to obtain current user info",
    "claim_failed": "Claim Failed",
    "no_comment_placeholder": "No Comment Placeholder",
    "no_threshold": "No Threshold",
    "no_need_join_again": "No need to join again",
    "day_char": "Day",
    "calendar": "Calendar",
    "date": "Date",
    "date_select": "Date Select",
    "date_picker": "Date Picker",
    "old_version": "Old Version",
    "times_paradise_walk": "Longfor Paradise Walk",
    "display_when": "Display When",
    "timestamp_setting": "Timestamp Setting",
    "timeline_content": "Timeline Content",
    "timeline_icon": "Timeline Icon",
    "timeline_area": "Timeline Area",
    "timeline_line": "Timeline Line",
    "time_select": "Time Select",
    "time_picker_modal": "Time Picker Modal",
    "tomorrow": "Tomorrow",
    "detail_list": "Detail List",
    "star_domain_commander": "Star Domain Commander",
    "star_domain_overlord": "Star Domain Overlord",
    "starbucks": "Starbucks",
    "zodiac_tag": "Zodiac Tag",
    "save_modified_info_confirm": "Save modified info?",
    "delete_address_confirm": "Delete this address?",
    "enable_follow_reward_confirm": "Enable follow reward?",
    "delete_account_confirm": "Delete account?",
    "delete_territory_confirm": "Delete territory?",
    "leave_territory_confirm": "Leave territory?",
    "auto_focus_confirm": "Auto focus?",
    "logout_confirm": "Logout?",
    "nickname": "Nickname",
    "after_nickname_birthday": "After nickname and birthday",
    "nickname_no_politics": "No politics in nickname",
    "after_nickname": "After nickname",
    "nickname_and_badge": "Nickname and Badge",
    "nickname_and_badge_alt": "Nickname and Badge",
    "show_send_button": "Show Send Button",
    "show_province": "Show Province",
    "show_comment_count": "Show Comment Count",
    "show_default_action_button": "Show Default Action Button",
    "normal": "Normal",
    "normal_member": "Normal Member",
    "normal_product_card": "Normal Product Card",
    "normal_member_alt": "Normal Member",
    "normal_button_bind_success": "Normal button bind success",
    "smart_contract_desc": "Smart contract based on contribution to split revenue automatically",
    "temp_no_revoke": "Do not revoke for now",
    "temp_not_supported": "Not supported yet",
    "temp_no_video_upload": "Video upload not supported yet",
    "temp_no_select": "Do not select for now",
    "temp_none": "None",
    "temp_no_people_info": "No people info",
    "temp_no_coupon": "No coupon available",
    "temp_no_member_card_info": "No member card info",
    "temp_no_content": "No content",
    "temp_no_product": "No product",
    "temp_no_address": "No address",
    "temp_no_signup_info": "No signup info",
    "temp_no_revenue": "No revenue",
    "temp_no_shipping_address": "No shipping address",
    "temp_no_data": "No data",
    "temp_no_time_info": "No time info",
    "temp_no_order": "No order",
    "temp_no_invite_data": "No invite data",
    "temp_no_invite_record": "No invite record",
    "temp_no_bank_data": "No bank data",
    "temp_no_store": "No store",
    "temp_no_territory_intro": "No territory intro",
    "temp_no_more": "No more data",
    "temp_not_used": "Not used yet",
    "temp_not_joined_store": "Not joined store yet",
    "more": "More",
    "more_vouchers": "More Vouchers",
    "more_placeholder": "More Placeholder",
    "more_rewards": "More Rewards",
    "more_buttons": "More Buttons",
    "more_powerful": "More Powerful",
    "change_avatar": "Change Avatar",
    "change_bank_card": "Change Bank Card",
    "lowest": "Lowest",
    "most": "Most",
    "max_upload": "Max Upload",
    "max_send": "Max Send",
    "max_display": "Max Display",
    "final_earn_amount_hint": "Final earn amount subject to actual settlement",
    "final_interpretation_rights": "Final interpretation belongs to platform",
    "recent": "Recent",
    "recent_search": "Recent Search",
    "highest": "Highest",
    "max_earn": "Max Earn",
    "month": "Month",
    "monthly_sales": "Monthly Sales",
    "monthly_sales_volume": "Monthly Sold",
    "help_merchant_handle_after_sales": "Help merchant handle after-sales better",
    "show_when_has_address": "Show when has address",
    "validity_period": "Validity Period",
    "validity_type": "Validity Type",
    "validity_type_selector": "Validity Type Selector",
    "valid_until": "Valid Until",
    "validity_selection": "Validity Selection",
    "service": "Service",
    "service_unavailable": "Service Unavailable",
    "server_error": "Server Error",
    "service_not_implemented": "Service Not Implemented",
    "service_tag_and_sales": "Service Tag and Sales",
    "service_type": "Service Type",
    "service_order": "Service Order",
    "service_fee": "Service Fee",
    "chaoyang_district": "Chaoyang District",
    "uninitialized": "Uninitialized",
    "dont_give_code_before_arrival": "Do not give code to merchant before arrival",
    "location_permission_not_enabled": "Location permission not enabled",
    "not_on_sale_but_reserved": "Not on sale but reserved",
    "not_on_sale_and_not_reserved": "Not on sale and not reserved",
    "minors_cannot_recharge": "Minors cannot recharge",
    "not_found": "Not Found",
    "related_bank_not_found": "Related Bank Not Found",
    "certificate_element_not_found": "Certificate Element Not Found",
    "unauthorized": "Unauthorized",
    "not_received_goods": "Not Received Goods",
    "phone_not_registered_territory": "Phone not registered in Territory",
    "not_logged_in": "Not Logged In",
    "unknown": "Unknown",
    "unknown_merchant": "Unknown Merchant",
    "unknown_user": "Unknown User",
    "unknown_error": "Unknown Error",
    "not_obtained": "Not Obtained",
    "parent_dim_not_obtained": "Parent dimension not obtained",
    "image_data_not_obtained": "Image data not obtained",
    "nickname_not_set": "Nickname not set",
    "unclaimed_red_packet": "Unclaimed Red Packet",
    "commission_this_order": "Commission This Order",
    "hot_sale_this_week": "Hot Sale This Week",
    "hot_this_week": "Hot This Week",
    "withdraw_amount_this_time": "Withdraw Amount This Time",
    "rights": "Rights",
    "rights_updated_regularly": "Rights Updated Regularly",
    "rights_desc": "Rights Desc",
    "permission_denied": "Permission Denied",
    "permission_hint": "Permission Hint",
    "permission_not_enabled": "Permission Not Enabled",
    "strip": "Strip",
    "connections_count": "Connections Count",
    "replies_count": "Replies Count",
    "local_life_videos_count": "Local Life Videos Count",
    "bar_chart": "Bar Chart",
    "comments_count": "Comments Count",
    "introduce_your_territory": "Introduce your Territory",
    "mainland_travel_permit_hkmc": "Mainland Travel Permit for HK/Macau Residents",
    "mainland_travel_permit_taiwan": "Mainland Travel Permit for Taiwan Residents",
    "come_see_my_homepage": "Come see my homepage",
    "from_source": "From",
    "hangzhou_city": "Hangzhou",
    "view": "View",
    "view_personal_homepage": "View Personal Homepage",
    "view_all": "View All",
    "view_coupon_code": "View Coupon Code",
    "view_full_ranking": "View Full Ranking",
    "view_promotion_record": "View Promotion Record",
    "view_more": "View More",
    "view_more_exciting": "View More Exciting",
    "view_logistics": "View Logistics",
    "view_cash_balance": "View Cash Balance",
    "view_order": "View Order",
    "view_order_status": "View Order Status",
    "view_detail": "View Detail",
    "view_store": "View Store",
    "view_territory": "View Territory",
    "column_chart": "Column Chart",
    "tag": "Tag",
    "tag_and_desc": "Tag and Desc",
    "tag_row": "Tag Row",
    "mark_location": "Mark Location",
    "title": "Title",
    "title_and_badge_area": "Title and Badge Area",
    "title_and_desc": "Title and Desc",
    "title_slot": "Title Slot",
    "title_bar": "Title Bar",
    "title_mode": "Title Mode",
    "validating": "Validating",
    "validation_failed": "Validation Failed",
    "validation_passed": "Validation Passed",
    "according_to": "According to",
    "render_template_by_share_type": "Render template by share type",
    "compliance_requirements": "Compliance Requirements",
    "format": "Format",
    "offline_places_like_table_card": "Offline places like table card",
    "device_brand_detected": "Device brand detected",
    "mode": "Mode",
    "mode_not_support_refresh": "Mode not support refresh",
    "after_mode": "After Mode",
    "template_injected_at_runtime": "Template injected at runtime",
    "template_gen_share_cover": "Template gen share cover",
    "blur_background": "Blur Background",
    "horizontal_scroll_info": "Horizontal Scroll Info",
    "horizontal_scroll_image_list": "Horizontal Scroll Image List",
    "showcase": "Showcase",
    "showcase_share_card": "Showcase Share Card",
    "showcase_card_template": "Showcase Card Template",
    "showcase_status": "Showcase Status",
    "showcase_bg_image": "Showcase BG Image",
    "showcase_page": "Showcase Page",
    "times": "Times",
    "times_recharge": "Times Recharge",
    "refresh_purchase_count_next_day": "Refresh purchase count next day",
    "welcome_to": "Welcome to",
    "welcome_to_territory": "Welcome to Territory",
    "is_being": "Is Being",
    "is_downloading": "Is Downloading",
    "is_loading_more": "Is Loading More",
    "is_loading_bank_list": "Is Loading Bank List",
    "is_processing": "Is Processing",
    "is_paying": "Is Paying",
    "is_chatting": "Is Chatting",
    "generating_image": "Generating Image",
    "generating_poster": "Generating Poster",
    "trigger_business_normal": "Trigger Business Normal",
    "moment_content_by": "Moment content by",
    "phone_used_for_merchant_login": "Phone used for merchant login",
    "step_list": "Step List",
    "persistence_pays_off": "Persistence Pays Off",
    "each": "Each",
    "limit_per_person": "Limit per person",
    "max_earn_per_order": "Max Earn Per Order",
    "daily_buy_limit_restricted": "Daily buy limit restricted",
    "commission_ratio_per_time": "Commission Ratio Per Time",
    "drugs_text_info": "Drugs Text Info",
    "ratio": "Ratio",
    "bubble_content": "Bubble Content",
    "bubble_chart": "Bubble Chart",
    "permanent": "Permanent",
    "accumulate_personal_digital_assets": "Accumulate Personal Digital Assets",
    "accumulate_high_quality_relations": "Accumulate High Quality Relations",
    "no_add_to_cart_feature": "No add to cart feature",
    "no_more_data": "No more data",
    "no_more_data_text": "No more data",
    "no_more_data_hint": "No more data hint",
    "no_valid_business_data": "No valid business data",
    "attention": "Attention",
    "delete_account": "Delete Account",
    "activity": "Activity",
    "activity_people_count": "Activity People Count",
    "activity_intro": "Activity Intro",
    "activity_list": "Activity List",
    "activity_profit_ratio": "Activity Profit Ratio",
    "activity_location": "Activity Location",
    "activity_signup": "Activity Signup",
    "activity_calendar": "Activity Calendar",
    "activity_time": "Activity Time",
    "activity_detail": "Activity Detail",
    "delivering": "Delivering",
    "traffic_content_asset_chain": "Traffic content asset chain",
    "test": "Test",
    "test_address": "Test Address",
    "zhejiang_province": "Zhejiang",
    "poster_card_container": "Poster Card Container",
    "poster_modal": "Poster Modal",
    "poster_promote": "Poster Promote",
    "poster_generating": "Poster Generating",
    "haidian_district": "Haidian",
    "message": "Message",
    "message_list": "Message List",
    "message_red_dot": "Message Red Dot",
    "shenzhen_city": "Shenzhen",
    "shenzhen_territory_tech": "Shenzhen Territory Tech Co., Ltd.",
    "mixed_chart": "Mixed Chart",
    "add_follow_failed": "Add Follow Failed",
    "add_image_button": "Add Image Button",
    "add_address": "Add Address",
    "add_failed": "Add Failed",
    "add_success": "Add Success",
    "bar": "Bar",
    "clear_cart": "Clear Cart",
    "clear_search_history": "Clear Search History",
    "gradient_top": "Gradient Top",
    "gradient_mask": "Gradient Mask",
    "channel": "Channel",
    "channel_member": "Channel Member",
    "warm_tips": "Warm Tips",
    "hkmc_resident_permit": "HK/Macau Resident Permit",
    "render_chart": "Render Chart",
    "render_sub_reply_list": "Render Sub Reply List",
    "hunan_province": "Hunan",
    "full": "Full",
    "funnel_chart": "Funnel Chart",
    "activate": "Activate",
    "activate_distributor": "Activate Distributor",
    "activate_distributor_title": "Activate Distributor Title",
    "waterfall": "Waterfall",
    "waterfall_content": "Waterfall Content",
    "inspiration_burst": "Inspiration Burst",
    "lingdie_limited_avatar_frame": "Lingdie Limited Avatar Frame",
    "lingdie_limited_frame_particle": "Lingdie Limited Avatar Frame Particle",
    "point": "Point",
    "click": "Click",
    "click_upload": "Click Upload",
    "click_button_below": "Click Button Below",
    "click_button_below_view": "Click Button Below View",
    "clicked_center_bump": "Clicked Center Bump",
    "click_to_join_store": "Click to Join Store",
    "click_go_group_buy": "Click to Group Buy",
    "click_go_look": "Click to Have a Look",
    "click_button": "Click Button",
    "click_view": "Click to View",
    "click_view_moment_detail": "Click to View Moment Detail",
    "click_view_activity_detail": "Click to View Activity Detail",
    "click_claim_now": "Click to Claim Now",
    "click_trigger_business": "Click to Trigger Business Logic",
    "click_retry": "Click to Retry",
    "like": "Like",
    "like_content": "Like Content",
    "like_success": "Like Success",
    "like_button": "Like Button",
    "like_count": "Like Count",
    "like_data": "Like Data",
    "like_message": "Like Message",
    "like_comment": "Like Comment",
    "calendar_remind_time": "Time to Calendar Remind",
    "hot_sales_ranking": "Hot Sales Ranking",
    "hot_sales_rank": "Hot Sales Rank",
    "hot_sales": "Hot Sales",
    "hot_products": "Hot Products",
    "hot_merchants": "Hot Merchants",
    "hot_rank": "Hot Rank",
    "best_selling": "Best Selling",
    "parent_menu": "Parent Menu",
    "version": "Version",
    "version_not_supported": "Version Not Supported",
    "version_no": "Version No",
    "version_suffix": "Version Suffix",
    "logistics": "Logistics",
    "logistics_info": "Logistics Info",
    "logistics_company": "Logistics Company",
    "logistics_company_modal": "Logistics Company Modal",
    "logistics_timeline": "Logistics Timeline",
    "logistics_fast": "Logistics Fast",
    "featured_tag": "Featured Tag",
    "status_tab": "Status Tab",
    "status_bar_placeholder": "Status Bar Placeholder",
    "status_code": "Status Code",
    "exclusive_debut": "Exclusive Debut",
    "cat_dog_general": "Cat Dog General",
    "return_of_king": "Return of King",
    "gameplay_rules": "Gameplay Rules",
    "rose_chart": "Rose Chart",
    "environment": "Environment",
    "cash_balance": "Cash Balance",
    "reason_alt": "Reason",
    "luckin_coffee": "Luckin Coffee",
    "bottle_beer": "Bottle Beer",
    "generate": "Generate",
    "generate_qrcode_failed": "Generate QR Code Failed",
    "generate_share_image": "Generate Share Image",
    "generate_share_cover": "Generate Share Cover",
    "generate_image_timeout": "Generate Image Timeout",
    "generate_suncode_failed": "Generate Suncode Failed",
    "generate_miniapp_link_failed": "Generate Miniapp Link Failed",
    "generate_promote_fingerprint_failed": "Generate Pormote Fingerprint Failed",
    "generate_poster": "Generate Poster",
    "generating_poster_status": "Generating Poster",
    "generating_certificate": "Generating Certificate",
    "generate_link_failed": "Generate Link Failed",
    "birthday": "Birthday",
    "use_prep": "Use",
    "used_for_screenshot": "Used for screenshot",
    "used_for_pregen_share_cover": "Used for pre-generate share cover",
    "user": "User",
    "user_homepage": "User Homepage",
    "user_homepage_card_template": "User Homepage Card Template",
    "user_info": "User Info",
    "user_info_content": "User Info Content",
    "user_info_loading": "User Info Loading",
    "user_info_section": "User Info Section",
    "user_info_area": "User Info Area",
    "user_info_card": "User Info Card",
    "user_info_row": "User Info Row",
    "user_followed_you": "User Followed You",
    "user_share_card": "User Share Card",
    "user_list": "User List",
    "user_moment_card": "User Moment Card",
    "user_medal": "User Medal",
    "user_agreement": "User Agreement",
    "username_and_avatar": "Username and Avatar",
    "user_avatar": "User Avatar",
    "user_avatar_as_bg": "User Avatar as Background",
    "user_avatar_list": "User Avatar List",
    "after_user_scan": "After user scan",
    "user_invite_merchant": "User Invite Merchant",
    "user_nickname": "User Nickname",
    "user_not_login": "User Not Login",
    "user_level": "User Level",
    "user_red_packet_protocol": "User Red Packet Protocol",
    "user_contribution": "User Contribution",
    "user_logout": "User Logout",
    "user_privacy_policy": "User Privacy Policy",
    "apply_create_territory": "Apply Create Territory",
    "apply_collaboration": "Apply Collaboration",
    "apply_after_sales": "Apply After Sales",
    "after_apply_audit_passed": "After apply audit passed",
    "apply_time": "Apply Time",
    "apply_refund": "Apply Refund",
    "phone": "Phone",
    "phone_number_error": "Phone Number Error",
    "male": "Male",
    "canvas": "Canvas",
    "speak_freely": "Speak Freely",
    "speak_freely_system_upgrade": "Speak Freely System Upgrade",
    "login": "Login",
    "logging_in": "Logging in",
    "after_login": "After Login",
    "login_failed_alt": "Login Failed",
    "login_expired": "Login Expired",
    "login_success": "Login Success",
    "login_phone": "Login Phone",
    "auto_register_at_login": "Auto register at login",
    "login_form_area": "Login Form Area",
    "white_background": "White Background",
    "white_bg_card": "White Background Card",
    "white_transparent_mask": "White Transparent Mask",
    "white_clam_butterfly": "White Clam Butterfly",
    "silver_navigator": "Silver Navigator",
    "percentage": "Percentage",
    "of_de": "of",
    "of_follow": "'s Follow",
    "of_group_buy": "'s Group Buy",
    "of_processing": "Processing",
    "of_recommend": "'s Recommend",
    "of_showcase": "'s Showcase",
    "of_fans": "'s Fans",
    "of_drawing_context": "of drawing context and pass in",
    "blind_box_product_name": "Blind Box Product Name",
    "blind_box_product_image": "Blind Box Product Image",
    "direct_download": "Direct Download",
    "live_streaming": "Live Streaming",
    "related_recommend": "Related Recommend",
    "equivalent_to": "Equivalent to",
    "province_list": "Province List",
    "province_level": "Province Level",
    "real_name": "Real Name",
    "known_it": "Known It",
    "confirm": "Confirm",
    "confirm_delete": "Confirm Delete",
    "confirm_equip": "Confirm Equip",
    "confirm_delete_moment": "Confirm delete moment?",
    "confirm_clear_cart": "Confirm clear all items in cart?",
    "confirm_unfollow": "Confirm unfollow?",
    "confirm_cancel_order": "Confirm cancel order?",
    "confirm_revoke_after_sales": "Confirm revoke after-sales?",
    "confirm_buy": "Confirm Buy",
    "confirm_alt": "Confirm",
    "confirm_cancel_payment": "Confirm cancel payment?",
    "confirm_revoke": "Confirm Revoke",
    "confirm_pay": "Confirm Pay",
    "confirm_pay_button": "Confirm Pay Button",
    "confirm_receipt": "Confirm Receipt",
    "after_confirm_receipt": "After Confirm Receipt",
    "confirm_receipt_success": "Confirm Receipt Success",
    "confirm_clear_search_history": "Confirm clear all search history?",
    "confirm_order": "Confirm Order",
    "gift": "Gift",
    "blessing": "Blessing",
    "leave_territory": "Leave Territory",
    "private_domain_fission": "Private Domain Fission",
    "qiuyun": "Qiuyun",
    "qiuyun_charts": "Qiuyun High Perf Cross-Platform Charts",
    "share_type_kinds": "Kinds of share types",
    "seconds": "Seconds",
    "expire_in_seconds": "Expire in seconds",
    "seconds_video": "Seconds Video",
    "sold_out_in_seconds": "Sold out in seconds",
    "points": "Points",
    "points_module": "Points Module",
    "operate_remove_in_detail": "Operate remove in detail page",
    "remove_success": "Remove Success",
    "remove_channel": "Remove Channel",
    "rare": "Rare",
    "hollow_star": "Hollow Star",
    "empty_data_state": "Empty Data State",
    "empty_state": "Empty State",
    "recharge_now": "Recharge Now",
    "open_now": "Open Now",
    "own_now": "Own Now",
    "view_now": "View Now",
    "activate_digital_product_now": "Activate Digital Product Now",
    "checkin_now": "Checkin Now",
    "verify_now": "Verify Now",
    "buy_now": "Buy Now",
    "book_now": "Book Now",
    "claim_now": "Claim Now",
    "placeholder_pos": "Placeholder",
    "symbol": "Symbol",
    "rank_prefix": "No.",
    "step_one": "Step One",
    "received_next_day": "Received next day",
    "step_two": "Step Two",
    "etc": "Etc",
    "level_list": "Level List",
    "level_upgrade": "Level Upgrade",
    "higher_level": "Higher Level",
    "spec_options_available": "Spec Options Available",
    "filter_button": "Filter Button",
    "filter_tag": "Filter Tag",
    "filter_bar": "Filter Bar",
    "filter_mask": "Filter Mask",
    "checkin_days": "Check-in Days",
    "checkin_success": "Check-in Success",
    "checkin_remind": "Check-in Remind",
    "checkin_remind_on": "Check-in Remind On",
    "checkin_calendar": "Check-in Calendar",
    "checkin_grid": "Check-in Grid",
    "checkin_rank": "Check-in Rank",
    "signature_alt": "Signature",
    "signature_no_politics": "No politics in signature",
    "signature_param_incomplete": "Signature param incomplete",
    "sign_distributor_contract": "Sign Distributor Contract",
    "management": "Management",
    "admin": "Admin",
    "meter": "Meter",
    "type": "Type",
    "type_incorrect": "Type Incorrect",
    "type_will_be_at": "Type will be at",
    "fans": "Fans",
    "fans_count_etc": "Fans and follows count",
    "yue_province": "Yue (Guangdong)",
    "series": "Series",
    "series_count": "Series Count",
    "series_product": "Series Product",
    "system": "System",
    "system_message": "System Message",
    "purple_background": "Purple Background",
    "accumulate_led": "Accumulate Ling Point",
    "accumulate_lzd": "Accumulate Ling Diamond",
    "accumulate_revenue": "Accumulate Revenue",
    "accumulate_revenue_amount": "Accumulate Revenue Amount",
    "accumulate_obtain": "Accumulate Obtain",
    "accumulate_earn_commission": "Accumulate Earn Commission",
    "accumulate_invite": "Accumulate Invite",
    "accumulate_invite_count": "Accumulate Invite Count",
    "red_packet": "Red Packet",
    "red_packet_count": "Red Packet Count",
    "red_packet_count_limit": "Red Packet Count Limit",
    "red_packet_share_card": "Red Packet Share Card",
    "level_distributor": "Level Distributor",
    "level_territory": "Level Territory",
    "line_chart_alt": "Line Chart",
    "component_gen_qrcode": "Component generate QR code",
    "combined_use": "Combined Use",
    "bind_success": "Bind Success",
    "bind_phone": "Bind Phone",
    "bind_time": "Bind Time",
    "bind_invite_code": "Bind Invite Code",
    "bind_bank_card": "Bind Bank Card",
    "end": "End",
    "end_minute": "End Minute",
    "end_hour": "End Hour",
    "end_time": "End Time",
    "settling": "Settling",
    "settlement_record": "Settlement Record",
    "draw_avatar_failed": "Draw Avatar Failed",
    "bring_to_holder": "Bring to holder",
    "stats_data": "Stats Data",
    "continue_open": "Continue Open",
    "continue_pay": "Continue Pay",
    "green_dot": "Green Dot",
    "removed_at_compile": "Removed at compile",
    "edit_address": "Edit Address",
    "edit_shipping_address": "Edit Shipping Address",
    "missing": "Missing",
    "network_upload_failed": "Network Upload Failed",
    "network_timeout": "Network Timeout",
    "network_connect_failed": "Network Connect Failed",
    "network_error": "Network Error",
    "pin_top": "Pin Top",
    "pinned_message": "Pinned message",
    "operate_pin_in_detail": "Operate pin in detail",
    "pin_success": "Pin Success",
    "pin_comment": "Pin Comment",
    "but_is": "But is",
    "contact_support": "Contact Support",
    "contact_phone": "Contact Phone",
    "alliance": "Alliance",
    "alliance_price": "Alliance Price",
    "alliance_showcase": "Alliance Showcase",
    "alliance_is_good": "Alliance is good",
    "alliance_self_buy_price": "Alliance Self Buy Price",
    "background": "Background",
    "background_image": "Background Image",
    "background_image_alt": "Background Image Alt",
    "victory_in_sight": "Victory in sight",
    "auto_join_your_territory": "Auto join your territory",
    "auto_login_failed": "Auto login failed",
    "customize": "Customize",
    "custom_loading_state": "Custom Loading State",
    "custom_legend": "Custom Legend",
    "custom_image_preview": "Custom Image Preview",
    "custom_navbar": "Custom Navbar",
    "custom_indicator": "Custom Indicator",
    "custom_time": "Custom Time",
    "custom_type": "Custom Type",
    "custom_error_hint": "Custom Error Hint",
    "self_earn_commission_reward": "Self earn commission reward",
    "pickup": "Pickup",
    "pickup_time_select": "Pickup Time Select",
    "pickup_code": "Pickup Code",
    "self_buy_save_money": "Self buy save money",
    "to_range": "To",
    "porn": "Porn",
    "node": "Node",
    "node_get_failed": "Node get failed",
    "if_problem_not_solved": "If problem not solved",
    "if_phone_not_registered": "If phone not registered",
    "if_need_recharge_invoice": "If need recharge invoice",
    "honor_market_open_failed": "Honor Market Open Failed",
    "honor_market_timeout": "Honor Market Timeout",
    "obtain": "Obtain",
    "obtain_location_failed": "Obtain Location Failed",
    "obtain_location_permission_failed": "Obtain Location Permission Failed",
    "obtain_share_domain_failed": "Obtain Share Domain Failed",
    "obtain_dynamic_param_error": "Obtain Dynamic Param Error",
    "obtain_district_data_failed": "Obtain District Data Failed",
    "obtain_after_sales_reason_failed": "Obtain After Sales Reason Failed",
    "obtain_image_data_failed": "Obtain Image Data Failed",
    "obtain_city_data_failed": "Obtain City Data Failed",
    "obtain_suncode_failed": "Obtain Suncode Failed",
    "obtain_phone_failed": "Obtain Phone Failed",
    "obtain_data_failed": "Obtain Data Failed",
    "obtain_time": "Obtain Time",
    "obtain_detail": "Obtain Detail",
    "failed_to_obtain_user_information": "Failed to obtain user information",
    "obtained_of": "Obtained of",
    "obtain_street_data_failed": "Obtain Street Data Failed",
    "obtain_bank_list_failed": "Obtain Bank List Failed",
    "obtain_navigator_id": "Obtain Navigator ID",
    "obtain_verify_code": "Obtain Verify Code",
    "obtain_profit_share": "Obtain Profit Share",
    "obtain_higher_commission": "Obtain Higher Commission",
    "got_liked": "Got Liked",
    "caidekuai": "Caidekuai",
    "caidekuai_dish": "Caidekuai Dish",
    "feige": "Feige",
    "business_open": "Business Open",
    "business_license": "Business License",
    "business_hours": "Business Hours",
    "business_hours_picker": "Business Hours Picker",
    "business_status_time": "Business Status Time",
    "collection": "Collection",
    "collection_name": "Collection Name",
    "collection_hash": "Collection Hash",
    "collection_total_value_alt": "Collection Total Value",
    "collection_story": "Collection Story",
    "collection_certificate": "Collection Certificate",
    "xietta": "XieTta",
    "row": "Row",
    "row_auto_scroll": "Row Auto Scroll",
    "street_list": "Street List",
    "street_level": "Street Level",
    "supplementary_desc": "Supplementary Desc",
    "awakened": "Awakened",
    "liked_passive": "Liked Passive",
    "decoration_package": "Decoration Package",
    "xicheng_district": "Xicheng",
    "spec_select": "Spec Select",
    "spec_select_component": "Spec Select Component",
    "spec_options": "Spec Options",
    "video_upload_timeout": "Video Upload Timeout",
    "video_no_face": "Video No Face",
    "video_content": "Video Content",
    "video_area": "Video Area",
    "video_play_icon": "Video Play Icon",
    "video_format_invalid": "Video Format Invalid",
    "video_detail": "Video Detail",
    "badge_display": "Badge Display",
    "solve_problems_fast": "Solve problems fast",
    "parse": "Parse",
    "parse_upload_response_failed": "Parse Upload Response Failed",
    "parse_response_failed": "Parse Response Failed",
    "unlock_exclusive_rights": "Unlock Exclusive Rights",
    "unlock_merchant_privilege_digit": "Unlock merchant privilege digit",
    "unlock_merchant_privilege_collection": "Unlock merchant privilege collection",
    "trigger_wechat_phone_login": "Trigger WeChat phone login",
    "trigger_button": "Trigger Button",
    "order_info": "Order Info",
    "order_list": "Order List",
    "order_list_content": "Order List Content",
    "order_no_not_exist": "Order No Not Exist",
    "order_remark": "Order Remark",
    "order_total_and_action": "Order Total and Action",
    "order_total_amount": "Order Total Amount",
    "order_payment": "Order Payment",
    "order_count": "Order Count",
    "order_number": "Order Number",
    "order_detail": "Order Detail",
    "order_amount": "Order Amount",
    "auth_and_digital_assets": "Auth and Digital Assets",
    "auth_info_error": "Auth Info Error",
    "auth_failed": "Auth Failed",
    "auth_success": "Auth Success",
    "after_auth_success": "After Auth Success",
    "auth_type": "Auth Type",
    "auth_desc": "Auth Desc",
    "make_you_prettiest_boy": "Make you the prettiest boy",
    "set_as_default": "Set as Default",
    "set_as_default_shipping_address": "Set as Default Shipping Address",
    "device_download": "Device Download",
    "settings": "Settings",
    "set_as_member": "Set as Member",
    "set_success": "Set Success",
    "set_admin": "Set Admin",
    "design_draft": "Design Draft",
    "certificate_content_area": "Certificate Content Area",
    "id_card_portrait_side": "Portrait Side",
    "id_card_number": "ID Card Number",
    "id_card_national_emblem_side": "National Emblem Side",
    "id_card_validity_type": "ID Validity Type",
    "id_card_type": "ID Type",
    "evaluate": "Evaluate",
    "score": "Score",
    "score_number": "Score Number",
    "score_star": "Score Star",
    "score_row": "Score Row",
    "comment": "Comment",
    "comment_and_reply": "Comment and Reply",
    "commented_your_moment": "Commented your moment",
    "comment_content": "Comment Content",
    "comment_list_scroll_container": "Comment List Scroll Container",
    "comment_area": "Comment Area",
    "comment_deleted": "Comment Deleted",
    "comment_button": "Comment Button",
    "comment_action": "Comment Action",
    "comment_count": "Comment Count",
    "comment_body": "Comment Body",
    "comment_user_avatar": "Comment User Avatar",
    "recognize": "Recognize",
    "recognize_failed": "Recognize Failed",
    "recognize_success": "Recognize Success",
    "word_cloud_chart": "Word Cloud Chart",
    "product_not_in_selection_library": "Product not in selection library",
    "user_account_cancelled": "User account cancelled",
    "spec_out_of_stock": "Spec out of stock",
    "territory_deleted": "Territory deleted",
    "detail": "Detail",
    "detailed_address": "Detailed Address",
    "detailed_address_info": "Detailed Address Info",
    "say_something": "Say something",
    "please_upload_id_card": "Please upload ID card image",
    "please_scroll_read_protocol": "Please scroll to read protocol to continue",
    "please_download": "Please Download",
    "please_download_amap": "Please download Amap",
    "please_use": "Please Use",
    "please_use_app_or_miniapp": "Please use app or mini-app",
    "please_recharge_and_retry": "Please recharge and retry",
    "please_upload_back_image_first": "Please upload back image first",
    "please_upload_image_first": "Please upload image first",
    "please_negotiate_with_merchant_first": "Please negotiate with merchant first",
    "please_complete_real_name_auth_first": "Please complete real-name auth first",
    "please_login_first": "Please login first",
    "please_check_in_personal_wallet": "Please check in personal wallet",
    "please_update_app_version": "Please update app version",
    "please_open_in_wechat": "Please open in WeChat",
    "please_go_to_settings_enable": "Please go to settings to enable",
    "dont_believe_brushing": "Do not believe in brushing scams",
    "please_consult_territory": "Please consult territory",
    "please_select_location_in_list": "Please select location in list below",
    "please_pay_in_wechat_browser": "Please pay in WeChat browser",
    "please_enable_calendar_permission_in_settings": "Please enable calendar permission in settings",
    "please_enable_permission_in_settings": "Please enable permission in settings",
    "please_fill_address": "Please fill address",
    "please_fill_name": "Please fill name",
    "please_fill_phone": "Please fill phone",
    "please_fill_detailed_address": "Please fill detailed address",
    "please_wait_patiently": "Please wait patiently",
    "please_fill_manually": "Please fill manually",
    "please_open_location_permission": "Please open location permission",
    "please_participate_on_time": "Please participate on time",
    "please_change_here": "Please change here",
    "please_check_and_resubmit": "Please check and resubmit",
    "please_check_permission": "Please check permission",
    "please_check_network": "Please check network",
    "please_check_network_retry": "Please check network and retry",
    "please_check_network_or_contact_admin": "Please check network or contact admin",
    "please_check_network_or_config": "Please check network or config",
    "please_check_network_connection": "Please check network connection",
    "request_error": "Request Error",
    "request_send_failed": "Request Send Failed",
    "request_send_exception": "Request Send Exception",
    "request_send_success": "Request Send Success",
    "request_timeout": "Request Timeout",
    "invalid_request": "Invalid Request",
    "please_note_traffic": "Please note traffic",
    "please_click": "Please Click",
    "please_click_button_operate": "Please click button below to operate",
    "please_click_retry": "Please click to retry",
    "please_retry_later": "Please retry later",
    "please_wait": "Please Wait",
    "please_bind_view_message": "Please bind to view message",
    "please_wait_patiently_alt": "Please wait patiently",
    "please_wait_merchant_process": "Please wait for merchant to process",
    "please_keep_at_least_one_product": "Please keep at least one product",
    "please_retry_after_purchase": "Please retry after purchase",
    "please_input": "Please Input",
    "please_input_content": "Please input content",
    "please_input_merchant_name": "Please input merchant name",
    "please_input_name": "Please input name",
    "please_input_bank_card_no": "Please input bank card number",
    "please_input_bank_name": "Please input bank name",
    "please_input_tracking_no": "Please input tracking number",
    "please_input_nickname": "Please input nickname",
    "please_input_real_name": "Please input real name",
    "please_input_signature": "Please input signature",
    "please_input_phone": "Please input phone",
    "please_input_holder_address": "Please input holder address",
    "please_input_withdraw_amount": "Please input withdraw amount",
    "please_input_search_content": "Please input search content",
    "please_input_correct_info": "Please input correct info",
    "please_input_correct_phone": "Please input correct phone",
    "please_input_real_name_alt": "Please input real name",
    "please_input_auth_desc": "Please input auth description",
    "please_input_id_card_no": "Please input ID card number",
    "please_input_detailed_address": "Please input detailed address",
    "please_input_id_number": "Please input ID number",
    "please_input_invite_code": "Please input invite code",
    "please_input_bank_phone": "Please input reserved phone",
    "please_input_store_name": "Please input store name",
    "please_input_store_phone": "Please input store phone",
    "please_input_store_manager": "Please input store manager",
    "please_input_reserved_phone": "Please input reserved phone",
    "please_input_verify_code": "Please input verify code",
    "please_return_home_buy": "Please return to homepage to buy",
    "please_select": "Please Select",
    "please_select_payment_method": "Please select payment method",
    "please_select_send_location": "Please select send location",
    "please_select_pickup_time": "Please select pickup time",
    "please_select_after_sales_product": "Please select after-sales product",
    "please_select_product": "Please select product",
    "please_select_merchant_location": "Please select merchant location",
    "please_select_region": "Please select region",
    "please_select_city": "Please select city",
    "please_select_complete_address": "Please select complete address",
    "please_select_start_time": "Please select start time",
    "please_select_bank_address": "Please select bank branch address",
    "please_select_bank_province": "Please select bank province",
    "please_select_bank": "Please select bank",
    "please_select_delete_product": "Please select product to delete",
    "please_select_holder_id_type": "Please select holder ID type",
    "please_select_shipping_address": "Please select shipping address",
    "please_select_time": "Please select time",
    "please_select_validity_type": "Please select validity type",
    "please_select_logistics_company": "Please select logistics company",
    "please_select_pcd_street": "Please select prov/city/dist/street",
    "please_select_end_time": "Please select end time",
    "please_select_bg_image": "Please select bg image",
    "please_select_business_hours": "Please select business hours",
    "please_select_spec": "Please select specification",
    "please_select_id_validity_start": "Please select ID validity start",
    "please_select_id_validity_type": "Please select ID validity type",
    "please_select_id_validity_end": "Please select ID validity end",
    "please_select_buy_option": "Please select buy option",
    "please_select_store_type": "Please select store type",
    "please_select_store_location": "Please select store location",
    "please_relogin": "Please relogin",
    "please_retry": "Please retry",
    "please_long_press_save": "Please long press to save",
    "please_read_and_agree": "Please read and agree",
    "please_read_and_agree_protocol": "Please read and agree protocol",
    "call_failed": "Call Failed",
    "call_success": "Call Success",
    "invoke_payment_method": "Invoke Payment Method",
    "beware_scams": "Beware of Scams",
    "manager_info": "Manager Info",
    "contribution_value": "Contribution Value",
    "contribution_detail": "Contribution Detail",
    "contribution_is_ownership": "Contribution is Ownership",
    "bill": "Bill",
    "account_balance_insufficient": "Account Balance Insufficient",
    "goods_status": "Goods Status",
    "goods_status_modal": "Goods Status Modal",
    "buy": "Buy",
    "buy_my_shared_product": "Bought my shared product",
    "buy_feature_developing": "Buy feature developing",
    "after_buy": "After Buy",
    "buy_only_support_use": "Only support use after buy",
    "auto_equip_frame_after_buy": "Auto equip frame after buy",
    "buy_product_exception": "Buy product exception",
    "buy_avatar_frame": "Buy Avatar Frame",
    "buy_success": "Buy Success",
    "buy_specified_product_claim": "Buy specified product to claim",
    "buy_button": "Buy Button",
    "buy_digital_rights_join_territory": "Buy digital rights and join territory",
    "buy_digital_asset_auth_limit": "Real-name auth required for digital asset buy",
    "buy_digital_asset": "Buy Digital Asset",
    "buy_digital_rights_get_tasks": "Tasks available after buying digital rights",
    "buy_digital_rights_get_distribution": "Distribution rights after buying digital rights",
    "buy_digital_rights_get_rights": "Rights gained after buying digital rights",
    "buy_confirm": "Buy Confirm",
    "buy_options": "Buy Options",
    "purchase_notes": "Purchase Notes",
    "buy_ling_point": "Buy Ling Point",
    "buy_navigator": "Buy Navigator",
    "shopping_coupon": "Shopping Coupon",
    "shopping_cart": "Shopping Cart",
    "cart_empty": "Cart Empty",
    "cart_modal": "Cart Modal",
    "assets": "Assets",
    "asset_authentication": "Asset Authentication",
    "profile_update_failed": "Profile Update Failed",
    "profile_update_success": "Profile Update Success",
    "after_profile_complete": "After profile complete",
    "profile_completion": "Profile Completion",
    "resource_ability_monetization": "Resource and ability monetization",
    "resource_ability_digitization": "Resource ability digitization",
    "qualification_info": "Qualification Info",
    "empower_individual": "Empower Individual",
    "earn": "Earn",
    "earned": "Earned",
    "earn_more_rewards": "Earn More Rewards",
    "thumbs_up": "Like",
    "liked_your_moment": "Liked your moment",
    "liked_your_comment": "Liked your comment",
    "people_who_liked": "People who liked",
    "people_who_liked_modal": "People who liked modal",
    "gift_item": "Gift Item",
    "gift_amount": "Gift Amount",
    "gift_white_clam_message": "Gift White Clam Message",
    "from_price": "From",
    "super_value_price": "Super Value Price",
    "super_value_coupon": "Super Value Coupon",
    "timeout_unpaid": "Timeout Unpaid",
    "distance_from_you": "Distance from you",
    "distance_from_you_honor": "Distance from you",
    "distance_greater_than": "Distance greater than",
    "distance": "Distance",
    "distance_filter_item": "Distance Filter Item",
    "follow_buy_count": "Follow Buy Count",
    "follow_buy_count_tag": "Follow Buy Count Tag",
    "follow_gesture": "Follow Gesture",
    "jump_failed": "Jump Failed",
    "identity_info_error": "Identity Info Error",
    "identity_mark": "Identity Mark",
    "id_card": "ID Card",
    "id_card_upload": "ID Card Upload",
    "id_document_upload": "ID Document Upload",
    "id_document_image": "ID Document Image",
    "id_info": "ID Info",
    "id_info_form": "ID Info Form",
    "id_number": "ID Number",
    "id_card_photos": "ID Card Photos",
    "after_transform": "After Transform",
    "manage_community_easily": "Manage community easily",
    "glory_peak_arrival": "Glory peak arrival",
    "input_must_be_number": "Input must be number",
    "input_phone": "Input Phone",
    "input_sms_user_pass": "Input SMS user and pass",
    "input_id_info": "Input ID info",
    "input_amount_exceed_balance": "Input amount exceed balance",
    "input_verify_code": "Input Verify Code",
    "influencer_recommending": "Influencer Recommending",
    "influencer_recommend": "Influencer Recommend",
    "refund_if_expired": "Refund if Expired",
    "freight": "Freight",
    "freight_coupon": "Freight Coupon",
    "transporting": "Transporting",
    "transport_status_card": "Transport Status Card",
    "back": "Back",
    "return_data_format_error": "Return Data Format Error",
    "back_home": "Back Home",
    "no_one_commented_yet": "No one commented yet",
    "this_guy_is_lazy": "This guy is lazy",
    "this_is_active_interaction": "This is active interaction",
    "symbol_of_identity_status": "Symbol of identity status in community",
    "here_is_barren": "Here is barren",
    "enter_homepage": "Enter Homepage",
    "enter_homepage_arrow": "Enter Homepage Arrow",
    "enter_territory": "Enter Territory",
    "enter_shop": "Enter Shop",
    "enter_shop_button": "Enter Shop Button",
    "visit_shop": "Visit Shop",
    "progress_indicator": "Progress Indicator",
    "perform_operation": "Perform Operation",
    "manage_store": "Manage Store",
    "connection_error": "Connection Error",
    "connection_line": "Connection Line",
    "logout_alt": "Logout",
    "return_back": "Return",
    "refund": "Refund",
    "refunding": "Refunding",
    "refund_info": "Refund Info",
    "refund_product_info": "Refund Product Info",
    "refund_failed": "Refund Failed",
    "refund_closed": "Refund Closed",
    "refund_success": "Refund Success",
    "refund_no_fee": "No fee for refund",
    "refund_time": "Refund Time",
    "refund_reason": "Refund Reason",
    "refund_reason_modal": "Refund Reason Modal",
    "refund_apply_failed": "Refund Apply Failed",
    "refund_apply_submitted": "Refund Apply Submitted",
    "refund_progress": "Refund Progress",
    "refund_amount": "Refund Amount",
    "return_refund": "Return Refund",
    "exclusive_rights_for_you": "Exclusive rights for you",
    "applicable_shop": "Applicable Shop",
    "applicable_store": "Applicable Store",
    "adapt_notch_screen": "Adapt Notch Screen",
    "selection_square": "Selection Square",
    "selection_library": "Selection Library",
    "selection_cart": "Selection Cart",
    "optional_field": "Optional",
    "selection_done": "Selected",
    "select": "Select",
    "select_coupon": "Select Coupon",
    "select_location_failed": "Select Location Failed",
    "select_birth_date": "Select Birth Date",
    "select_after_sales_info": "Select After Sales Info",
    "select_after_sales_reason": "Select After Sales Reason",
    "select_after_sales_product": "Select After Sales Product",
    "select_after_sales_reason_alt": "Select After Sales Reason",
    "select_product": "Select Product",
    "select_product_image": "Select Product Image",
    "select_merchant": "Select Merchant",
    "select_image_failed": "Select Image Failed",
    "select_region": "Select Region",
    "select_city": "Select City",
    "select_start_time": "Select Start Time",
    "select_bank_address": "Select Bank Address",
    "select_gender": "Select Gender",
    "select_shipping_address": "Select Shipping Address",
    "select_date": "Select Date",
    "select_validity_type": "Select Validity Type",
    "select_status": "Select Status",
    "select_end_time": "Select End Time",
    "select_goods_status": "Select Goods Status",
    "select_bank_card": "Select Bank Card",
    "select_store_type": "Select Store Type",
    "select_territory_bg": "Select Territory Background",
    "select_territory_bg_image": "Select Territory Background Image",
    "transparent": "Transparent",
    "transparent_mask": "Transparent Mask",
    "usually_an_image": "Usually an image",
    "via_nft_issue_community": "Via NFT issue and community operation",
    "traverse_comment_list": "Traverse comment list",
    "mask_layer": "Mask Layer",
    "avoid_being": "Avoid being",
    "invite": "Invite",
    "inviter_avatar": "Inviter Avatar",
    "inviter_is_merchant": "Inviter is Merchant",
    "inviter_is_user": "Inviter is User",
    "inviter_nickname": "Inviter Nickname",
    "invite_you_join": "Invite you join",
    "invite_you_join_territory": "Invite you join territory",
    "invite_you_play_territory": "Invite you play territory",
    "invite_graph": "Invite Graph",
    "invite_card": "Invite Card",
    "invite_friends": "Invite Friends",
    "invite_friends_share_card": "Invite Friends Share Card",
    "invite_friends_join_community": "Invite Friends Join Community",
    "invite_friends_join_territory": "Invite Friends Join Territory",
    "invite_friends_button": "Invite Friends Button",
    "person_who_invited_me": "Person who invited me",
    "invite_hint": "Invite Hint",
    "invite_user_card_template": "Invite User Card Template",
    "invite_code": "Invite Code",
    "invite_code_not_exist": "Invite Code Not Exist",
    "invite_code_empty": "Invite Code Empty",
    "invite_code_copied": "Invite Code Copied",
    "invite_code_copied_clipboard": "Invite Code Copied to Clipboard",
    "partially_used": "Partially Used",
    "partially_shipped": "Partially Shipped",
    "partially_batch_event_failed": "Partially Batch Event Failed",
    "everyone_has_territory": "Everyone has territory",
    "make_territory_prosperous": "Make territory prosperous",
    "config": "Config",
    "config_updated": "Config Updated",
    "config_update": "Config Update",
    "delivery_method_switch": "Delivery Method Switch",
    "pub": "Pub",
    "adopt": "Adopt",
    "overlapping_avatars": "Overlapping Avatars",
    "chongqing_impression_city": "Chongqing Impression City",
    "chongqing_city": "Chongqing",
    "rejoin_queue": "Rejoin Queue",
    "resend": "Resend",
    "repay": "Repay",
    "retry": "Retry",
    "retry_too_many_times": "Retry too many times",
    "amount_info": "Amount Info",
    "amount_display": "Amount Display",
    "amount_show": "Amount Show",
    "lobster_supreme": "Lobster Supreme",
    "wallet_address": "Wallet Address",
    "diamond": "Diamond",
    "diamond_alt": "Diamond",
    "diamond_navigator": "Diamond Navigator",
    "bank_card_upload": "Bank Card Upload",
    "bank_card_doc_upload": "Bank Card Doc Upload",
    "bank_card_info": "Bank Card Info",
    "bank_card_form": "Bank Card Form",
    "bank_card_front": "Bank Card Front",
    "mint_date": "Mint Date",
    "chain_address": "Chain Address",
    "link_empty": "Link Empty",
    "link_failed": "Link Failed",
    "link_copied": "Link Copied",
    "link_copied_clipboard": "Link Copied to Clipboard",
    "link_generating": "Link Generating",
    "sales_volume": "Sales Volume",
    "sales_over": "Sales Over",
    "error": "Error",
    "error_banner": "Error Banner",
    "error_state": "Error State",
    "length_exceed_limit": "Length Exceed Limit",
    "long_press_qrcode": "Long Press QR Code",
    "long_press_modal": "Long Press Modal",
    "long_press_view_detail": "Long Press View Detail",
    "long_press_recognize": "Long Press Recognize",
    "long_term": "Long Term",
    "long_term_valid": "Long Term Valid",
    "long_term_no_end_time": "Long Term No End Time",
    "changsha_city": "Changsha",
    "store": "Store",
    "store_type": "Store Type",
    "store_type_picker": "Store Type Picker",
    "store_location": "Store Location",
    "store_info": "Store Info",
    "store_info_display": "Store Info Display",
    "store_settle_in": "Store Settle In",
    "store_card_template": "Store Card Template",
    "store_name": "Store Name",
    "store_image": "Store Image",
    "store_desc": "Store Desc",
    "store_activity": "Store Activity",
    "store_phone": "Store Phone",
    "store_manager": "Store Manager",
    "store_selection_square": "Store Selection Square",
    "prevent_content_blocked_navbar": "Prevent content blocked by navbar",
    "nearby_places_list": "Nearby Places List",
    "downgrade_to_myapp": "Downgrade to MyApp",
    "downgrade_button": "Downgrade Button",
    "limit": "Limit",
    "limit_dine_in": "Limit Dine In",
    "limited": "Limited",
    "flash_sale": "Flash Sale",
    "limited_time_offer": "Limited Time Offer",
    "purchase_limit": "Purchase Limit",
    "limited_quantity": "Limited Quantity",
    "limited_sale": "Limited Sale",
    "limited_new_product": "Limited New Product",
    "use_freely": "Use Freely",
    "refund_anytime": "Refund Anytime",
    "privacy_protocol": "Privacy Protocol",
    "privacy_policy": "Privacy Policy",
    "hide": "Hide",
    "hide_render": "Hide Render",
    "gathered_people": "Gathered People",
    "retail": "Retail",
    "retail_product_detail": "Retail Product Detail",
    "retail_confirm_order": "Retail Confirm Order",
    "retail_order_detail": "Retail Order Detail",
    "retail_detail": "Retail Detail",
    "radar_chart": "Radar Chart",
    "demand_match": "Demand Match",
    "need_calendar_permission_add_reminder": "Need calendar permission to add reminder",
    "need_calendar_permission_add_reminder_alt": "Need calendar permission to add reminder",
    "need_album_permission_save_image": "Need album permission to save image",
    "need_self_obtain": "Need self obtain",
    "need_location_permission": "Need location permission",
    "non_distributor_status": "Non Distributor Status",
    "non_miniapp_show_cart": "Show cart when not in mini-app",
    "expect_interesting_stories": "Expect interesting stories",
    "placeholder_non_wechat_or_unready": "Placeholder when not in WeChat or unready",
    "show_only_non_wechat": "Show only when not in WeChat",
    "non_express_order": "Non Express Order",
    "non_business_hours": "Non Business Hours",
    "non_auth_digital_product_user_info_none": "Non auth and digital product and user info none",
    "panel": "Panel",
    "page_content": "Page Content",
    "page_loading_state": "Page Loading State",
    "page_header": "Page Header",
    "page_starts_rendering": "Page Starts Rendering",
    "page_visit": "Page Visit",
    "top_switch_bar": "Top Switch Bar",
    "top_area": "Top Area",
    "top_avatar_blessing": "Top Avatar Blessing",
    "top_navbar": "Top Navbar",
    "top_recommend_area": "Top Recommend Area",
    "top_text": "Top Text",
    "top_bg_card": "Top Background Card",
    "top_custom_navbar": "Top Custom Navbar",
    "top_decoration_bg": "Top Decoration Background",
    "top_invite_text": "Top Invite Text",
    "notice": "Notice",
    "estimated": "Estimated",
    "estimated_commission": "Estimated Commission",
    "estimated_commission_modal": "Estimated Commission Modal",
    "estimated_revenue": "Estimated Revenue",
    "estimated_max_earn": "Estimated Max Earn",
    "reserved_phone": "Reserved Phone",
    "reservation_person": "Reservation Person",
    "reservation_count": "Reservation Count",
    "reservation_success": "Reservation Success",
    "reservation_rank": "Reservation Rank",
    "reservation_ranking": "Reservation Ranking",
    "estimated_discount": "Estimated Discount",
    "estimated_commission_total": "Estimated Commission Total",
    "lord": "Lord",
    "claim": "Claim",
    "claim_exclusive_welfare": "Claim Exclusive Welfare",
    "claim_exclusive_red_packet": "Claim Exclusive Red Packet",
    "claim_list": "Claim List",
    "after_claim": "After Claim",
    "claim_reward_success": "Claim Reward Success",
    "claim_success": "Claim Success",
    "claim_button": "Claim Button",
    "claim_status": "Claim Status",
    "claim_territory_id_join": "Claim territory ID and join",
    "territory": "Territory",
    "territory_intro": "Territory Intro",
    "territory_task": "Territory Task",
    "territory_info": "Territory Info",
    "territory_value": "Territory Value",
    "territory_share_card": "Territory Share Card",
    "territory_share_modal": "Territory Share Modal",
    "territory_distribution_class": "Territory Distribution Class",
    "territory_list": "Territory List",
    "territory_moment": "Territory Moment",
    "territory_card_template": "Territory Card Template",
    "territory_create_success": "Territory create success",
    "territory_unveil_soon": "Territory unveil soon",
    "territory_original": "Territory Original",
    "territory_no": "Territory No",
    "territory_name": "Territory Name",
    "territory_start": "Territory Start",
    "territory_avatar": "Territory Avatar",
    "territory_service": "Territory Service",
    "territory_square": "Territory Square",
    "territory_member": "Territory Member",
    "territory_member_count": "Territory Member Count",
    "territory_member_tag": "Territory Member Tag",
    "territory_phone": "Territory Phone",
    "territory_checkin_miss_you": "Territory checkin miss you",
    "territory_promise_privacy": "Territory promise privacy",
    "territory_guide": "Territory Guide",
    "territory_search": "Territory Search",
    "territory_nft_mall": "Territory NFT Mall",
    "territory_data": "Territory Data",
    "territory_showcase": "Territory Showcase",
    "territory_activity": "Territory Activity",
    "territory_user": "Territory User",
    "territory_no_self_create": "Territory no self create",
    "territory_code": "Territory Code",
    "territory_selection": "Territory Selection",
    "territory_alliance": "Territory Alliance",
    "territory_bg_image": "Territory Background Image",
    "territory_bg_preview": "Territory Background Preview",
    "territory_help_user": "Territory help user",
    "territory_settings": "Territory Settings",
    "territory_detail": "Territory Detail",
    "territory_contribution": "Territory Contribution",
    "territory_notice": "Territory Notice",
    "territory_channel": "Territory Channel",
    "claim_reward": "Claim Reward",
    "ling_point": "Ling Point",
    "ling_point_balance": "Ling Point Balance",
    "ling_point_deduction": "Ling Point Deduction",
    "ling_point_deduction_display": "Ling Point Deduction Display",
    "ling_point_deducted": "Ling Point Deducted",
    "ling_point_red_packet": "Ling Point Red Packet",
    "ling_point_earn_nonstop": "Ling Point Earn Nonstop",
    "ling_point_page": "Ling Point Page",
    "navigator": "Navigator",
    "navigator_digital_asset_order": "Navigator Digital Asset Order",
    "navigator_digital_identity": "Navigator Digital Identity",
    "navigator_earn_per_order": "Navigator earn per order",
    "ling_diamond": "Ling Diamond",
    "ling_diamond_balance": "Ling Diamond Balance",
    "ling_diamond_insufficient": "Ling Diamond Insufficient",
    "ling_diamond_recharge": "Ling Diamond Recharge",
    "ling_diamond_mall": "Ling Diamond Mall",
    "ling_diamond_red_packet": "Ling Diamond Red Packet",
    "ling_diamond_buy_protocol": "Ling Diamond Buy Protocol",
    "channel_pin_top": "Channel Pin Top",
    "stars_count": "Stars Count",
    "color_extract_failed": "Color Extract Failed",
    "pie_chart": "Pie Chart",
    "first_post_interaction": "First post interaction",
    "first_asset": "First Asset",
    "homepage": "Homepage",
    "show_at_homepage": "Show at Homepage",
    "open_red_packet_now": "Open Red Packet Now",
    "verify_not_same_person": "Verify not same person",
    "verify_code_sent": "Verify code sent",
    "skeleton_loading": "Skeleton Loading",
    "height_fixed": "Height Fixed",
    "efficient_management_tool": "Efficient Management Tool",
    "gold_navigator": "Gold Navigator",
    "default": "Default",
    "default_is": "Default is",
    "default_group": "Default Group",
    "default_search_icon": "Default Search Icon",
    "default_title": "Default Title",
    "default_gift": "Default Gift",
    "default_empty_template": "Default Empty Template",
    "default_back_button": "Default Back Button",

    // Publish Dynamic Page
    "publish_dynamic": "Publish Dynamic",
    "publish": "Publish",
    "publishing": "Publishing",
    "publish_success": "Published Successfully",
    "add_title": "Add Title",
    "add_content": "Add Content",
    "link_territory": "Link Territory",
    "select_activity_product_store": "Select Activity/Product/Store",
    "no_activity_product_store_found": "No Activity/Product/Store Found",
    "get_more_rewards": "Get More Rewards",
    "discard_edit_confirm": "Discard editing?",
    "select_territory_developing": "Select Territory Feature Under Development",
    "select_activity_developing": "Select Activity Feature Under Development",

    // Select Location Page
    "search_location": "Search Location",
    "locating": "Locating",
    "location_failed": "Location Failed",
    "searching": "Searching",
    "please_select_location": "Please Select Location",
    "location_permission_required": "Location Permission Required",
    "location_permission_desc": "To provide better service, we need to access your location. Please allow location access in your browser settings.",
    "go_to_settings": "Go to Settings",
    "use_default_location": "Use Default Location",
    "please_enable_location_in_browser": "Please enable location permission in browser settings",
    "login_to_open_red_packet": "Login to open red packet now",
    "auto_register_if_not_registered": "If this phone number is not registered, we will automatically register for you",
    "code_sent_to": "Code sent to ",
    "cannot_login_try_again": "Cannot login? Try again",
    "please_input_4_digit_code": "Please enter 4-digit verification code",
    "send_failed_retry": "Send failed, please retry",
    "user_agreement_territory": "User Agreement (Territory)",
    "user_agreement_territory_bracket": "《User Agreement (Territory)》",
    "user_privacy_agreement_territory": "Privacy Policy (Territory)",
    "user_privacy_agreement_territory_bracket": "《Privacy Policy (Territory)》",
    "add_new_address": "Add New Address",
    "home": "Home",
    "get_location_failed_check_permission": "Failed to get location, please check permission",
    "need_location_permission_go_settings": "Location permission is required, please go to settings to enable",
    "get_location_permission_failed": "Failed to get location permission",
    "select_country_region": "Select Country/Region",
    "my_address": "My Address",
    "hong_kong": "Hong Kong",
    "macau": "Macau",
    "signature_params_incomplete": "Signature parameters incomplete",
    "year_month_format": "MMM YYYY",
    "after_year": "",
    "total_n_items": "Total {n} items",
    "get_dynamic_params_error": "Failed to get dynamic parameters",
    "joined_territory": "Territories joined",
    "check_my_homepage": "Check out my homepage~",
    "pending_use_receipt": "Pending Use/Receipt",
    "pending_evaluate": "Pending Review",
    "insufficient_balance": "Insufficient account balance",
    "rights_update_regularly": "Rights updated regularly",
    "and_claim_rewards": "and claim rewards",
    "already_hold_digital_product": "You already hold this digital product",
    "claim_success_check_wallet": "Claimed successfully, please check your wallet",
    "login_success_paying": "Login successful, processing payment",
    "details": "Details",
    "joint_venture": "Joint Venture",
    "from_territory_recommend": "Recommended by {name}, click to check it out~",
    "ido_digital_asset_order": "IDO Digital Asset Order",
    "goods_service_order": "Goods/Service Order",
    "page_back_triggered": "Page back triggered",
    "shipping": "Shipping",
    "pending": "Pending",
    "store_preparing": "Store Preparing",
    "pending_open_shop": "Pending Open",
    "pending_delivery": "Pending Delivery",
    "partial_delivery": "Partial Delivery",
    "partial_used": "Partial Used",
    "shopping_voucher": "Shopping Voucher",
    "freight_voucher": "Freight Voucher",
    "self_pickup": "Self Pickup",
    "after_sales_revoked_closed": "After-sales revoked, refund closed",
    "return_and_refund": "Return and Refund",
    "refund_to_wechat": "Refund to (WeChat)",
    "remark": "Remark",
    "refund_request_submitted_wait": "Refund request submitted, please wait for merchant to process",
    "merchant_no_confirm_auto_refund": " merchant not confirmed, will auto refund",
    "merchant_no_confirm_auto_agree": " merchant not confirmed, will auto agree after-sales",
    "issue_not_resolved_reapply_after": "If your issue is not resolved, you can reapply after ",
    "not_shipped_revoke_return": " not shipped, return request will be revoked",
    "merchant_no_refund_auto_refund": " merchant not refunded, will auto refund to you",
    "reapply_after_sales": " reapply after-sales",
    "cancel_revoke": "Cancel Revoke",
    "revoke_after_sales_retry": "Revoke after-sales failed, please try again later",
    "order_no": "Order No",
    "you_have_points": "You have {count} points",
    "use_points_deduct": "Use {points} points to deduct {amount}",
    "operation_failed_retry": "Operation failed, please try again",
    "balance_insufficient": "Insufficient account balance",
    "full_amount_available": "Available when over {amount}",
};
